import { nanoid } from "nanoid"

const diagramGroups = {
    'flowControl': { key: 'flowControl', title: 'Flow Controls' },

    'trigger': { key: 'trigger', title: 'Triggers' },
    'action': { key: 'action', title: 'Actions' },
    // 'condition': { key: 'condition', title: 'Conditions' },

    // 'proccess': { key: 'proccess', title: 'Proccess' }
}


const diagramComponents = {



    'workflowStart': {
        key: 'workflowStart',
        title: '{{lang}}Workflow start',
        group: 'trigger',

        UI: { type: "trigger", bodyColorE: "#dd4040", bodyColorS: "#ee5050", invertIcon: true, borderRadius: "50%", showIcon: '/assets/icons/forms/number.png', width: 70 },

        parents: ['workflowUnits'],
        icon: '/assets/icons/useful/stack1.png',
        headers: [
            { key: 'applet', type: 'SelectInput', col: '12', information: { label: '{{lang}}applet', type: 'api', address: 'getMyAppletList', filter: {}, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}insertLabel', required: true }, disabled: true },
            {
                key: 'frame', type: 'SelectInput', col: '12', information: { label: '{{lang}}frame', type: 'api', address: 'getFrames', filter: { applet: '{{appletId}}' }, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}frame', required: false }, showMain: false,
                dependencies: [{
                    refKey: 'applet',
                    targetKey: 'frame',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: '@data.applet' }, operator: { value: '!=' }, target: { value: null } },
                                // 1: { id: 1, source: { value: '@data.applet' }, operator: { value: '==' }, target: { value: 'frame' } },
                            }
                        },
                    },
                    show: true,
                    init: true,
                    changeHeader: { key: 'information.filter.applet', value: '@data.applet' },
                }],
            },
            { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}label', placeholder: '{{lang}}insertLabel', required: true } },
            { key: 'fields', type: 'SelectInput', col: '12', information: { label: '{{lang}}fields', placeholder: '{{lang}}insertFields' } },
            { key: 'value', type: 'TextInput', col: '12', information: { label: '{{lang}}value', placeholder: '{{lang}}insertValue', required: true } },
            // { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
        ],
        defaultNodes: {
            // 'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },


    'stage': {
        key: 'stage',
        title: 'Stage',
        group: 'operator',

        parents: ['workflowUnits'],

        UI: { type: 'stage', borderRadius: '8px', width: 100, height: 40, bodyColor: '#333', textColor: '#333', border: '1px solid #e0e0e0', bodyColorS: '#fff', bodyColorE: '#fff' },
        icon: '/assets/icons/useful/right (1).png',

        configuration: {
            id: nanoid()
        },
        headers: [
            { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}label', placeholder: '{{lang}}insertLabel', required: true } },
            { key: 'id', type: 'TextInput', col: '12', information: { label: '{{lang}}id', placeholder: '{{lang}}Stage ID', required: true, }, hideComponent: true },

            { key: 'color', type: 'AdvancedColorInput', col: 6, information: { label: '{{lang}}Color', placeholder: '{{lang}}Choose color', required: false } },
            { key: 'permissionsType', type: 'SelectInput', col: 6, information: { label: '{{lang}}Permissions type', defaultValue: 'follow', type: "local", items: [{ value: 'follow', title: '{{lang}}Follow collection permissions', }, { value: 'custom', title: '{{lang}}Custom permissions for this stage', }], placeholder: 'Choose...', required: true } },
            {
                key: 'admins', type: 'PermissionsInput', information: { type: 'api', address: 'searchUser', filter: { automation: '{{automationId}}', stage: '{{id}}' }, fields: { title: 'fullname', value: '_id', image: 'image' }, label: '{{lang}}Stage permissions', placeholder: '{{lang}}insertAdmins' },
                dependencies: [{
                    refKey: 'permissionsType', targetKey: 'admins',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.permissionsType' }, operator: { value: '==' }, target: { value: 'custom' } } }, },
                        effect: { show: true, changeHeader: [{ key: 'information.required', value: true }] }
                    }],
                    else: { show: false, changeHeader: [{ key: 'information.required', value: false }] },
                    init: true,
                    // show:true,

                }],
            },

            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },

        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },





    //Tasking

    //flowcontrol
    // 'getTask': {
    //     key: 'getTask',
    //     title: 'get task',
    //     group: 'operator',
    //     parents: ['Tasking'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    'condition': {
        key: 'condition',
        title: 'Condition',
        group: 'operator',
        UI: { type: 'condition', width: 120, borderRadius: 10, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/condition.svg' },

        // UI: { type: 'condition', bodyColor: '#D5CABD', bodyColorS: '#04004A', bodyColorE: '#250B65', showIcon: 'https://www.flaticon.com/svg/static/icons/svg/59/59118.svg' },
        icon: '/assets/icons/elements/split.png',
        parents: ['controlUnits'],

        headers: [
            { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}label', placeholder: '{{lang}}insertLabel', required: true } },
            // { key: 'label', type: 'FilterEditorInput', col: '12', information: { label: '{{lang}}label',  placeholder: '{{lang}}insertLabel', required: true } },
            // { type: 'NumberInput',col: '6', key: 'inputs', information: { label: '{{lang}}diagram.numberOfInputs', min: 1, placeholder: '{{lang}}diagram.numberOfInputs', default: 1, required: false } },
            // { type: 'NumberInput',col: '6', key: 'inputs', information: { label: '{{lang}}diagram.numberOfInputs', min: 1, placeholder: '{{lang}}diagram.numberOfInputs', default: 1, required: false } },

            // {
            //     type: 'SubformInput',
            //     key: 'inputs',
            //     col: '6',
            //     information: {
            //         label: '{{lang}}diagram.inputs',
            //         headers: [
            //             { type: 'FilterEditorInput', key: 'label', col: '12', information: { label: '{{lang}}diagram.label', placeholder: '{{lang}}diagram.label', required: true } },
            //         ],
            //         default: [{ label: 'input', '**notRemoveable': true }],
            //         placeholder: '{{lang}}placeholders.insertInformation',
            //         required: true
            //     }
            // },

            // {
            //     type: 'FilterEditorInput',
            //     key: 'outputs',
            //     col: '6',
            //     information: {

            //         label: '{{lang}}diagram.outputs',
            //         headers: [
            //             { type: 'TextInput', key: 'label', col: '12', information: { label: '{{lang}}diagram.label', placeholder: '{{lang}}diagram.label', required: true } },

            //         ],
            //         default: [{ label: 'default', '**notRemoveable': true }, { label: 'else' }],
            //         placeholder: '{{lang}}placeholders.insertInformation',
            //         required: true
            //     }
            // },

            {
                type: 'OutputsInput',
                key: 'outputs',
                information: {
                    label: '{{lang}}Component outputs',
                    inputClass: 'a',
                    // headers: [
                    //     // { type: 'FilterEditor', key: 'condition', col: '5', information: { label: '{{lang}}diagram.condition', placeholder: '{{lang}}diagram.condition', required: true } },
                    //     // { type: 'SmartInput', key: 'data', col: '5', information: { label: '{{lang}}diagram.outputValue', singleLine: true, placeholder: '{{lang}}diagram.outputValue', required: false } },
                    //     { type: 'TextInput', key: 'output', col: '2', information: { label: '{{lang}}diagram.output', type: 'local', items: [], placeholder: '{{lang}}Insert.Path', required: true } },
                    // ],
                    // hint: "{{lang}}decriptionAboutCharacteristics",
                    placeholder: '{{lang}}placeholders.insertInformation',

                    required: false
                },
                // dependencies: [{
                //     refKey: 'outputs',
                //     targetKey: 'structure',
                //     conditions: {
                //         root: {
                //             id: 'root',
                //             action: 'and',
                //             conditions: {
                //                 1: { id: 1, source: { value: '@data.label' }, operator: { value: '!=' }, target: { value: null } }
                //             }
                //         },
                //     },
                //     // show: true,
                //     changeHeader: { key: 'information.headers[key*==*output].information.items', value: '@data.outputs', converts: [{ targetKey: 'title', valueKey: 'label' }, { targetKey: 'value', valueKey: 'label' }] },

                // }],
            },
            {
                key: 'description',
                type: 'TextAreaInput',
                col: '12',
                information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false },
                // dependencies: [{
                //     refKey: 'label',
                //     targetKey: 'description',
                //     conditions: {
                //         root: {
                //             id: 'root',
                //             action: 'and',
                //             conditions: {
                //                 1: { id: 1, source: { value: '@data.label' }, operator: { value: '!=' }, target: { value: null } },
                //                 2: { id: 2, source: { value: '@data.label' }, operator: { value: '!=' }, target: { value: "" } },
                //             }
                //         },
                //     },
                //     show: true,
                //     // changeValue: true,
                //     // changeHeader: { key: 'information.placeholder', value: '@data.label' },
                //     // changeHeader: { key: 'hideComponent', value: '@data.label' },

                //     init: true

                // }],
            },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            // 'input-2': { key: 'input-2', label: 'Input 2', type: 'input', position: 'left' },
            'output-1': { key: 'output-1', label: 'Output', type: 'output', position: 'right', sort: 1 },
            'else': { key: 'else', label: 'else', type: 'output', position: 'right', sort: 1000 },
        }
    },


    'sendNotification': {
        key: 'sendNotification',
        title: 'send notification',
        group: 'action',
        parents: ['controlUnits'],
        UI: { type: 'action', borderRadius: '8px', width: 150, bodyColorS: '#fff', border: '1px solid #e0e0e0', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/useful/notification-bell.png',
        // icon: '/thirdparties/gmail1.webp',

        headers: [
            { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}label', placeholder: '{{lang}}title', required: true } },
            // { key: 'userId', type: '', col: '12', information: { label: '{{lang}}user id',  placeholder: '{{lang}}title', required: true } },
            { key: 'description ', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false } },

            { type: 'HubsAndGroupsInput', key: 'recipients', information: { label: '{{lang}}Recipients', address: 'searchUser', showConditions: true, filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', placeholder: '{{lang}}Select hubs and/or groups', required: true, } },

            { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}title', placeholder: '{{lang}}title', required: true } },
            { key: 'body', type: 'TextEditorInput', col: '12', information: { label: '{{lang}}body', showToolbar: true, placeholder: '{{lang}}title', required: true } },

            // { key: 'status', type: 'TextInput', col: '12', information: { label: '{{lang}}status', placeholder: '{{lang}}status', required: true } },
            // { key: 'project', type: 'TextInput', col: '12', information: { label: '{{lang}}project', placeholder: '{{lang}}project', required: true } },

        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },



    'createRecord': {
        key: 'createRecord',
        title: 'Create record',
        group: 'action',
        parents: ['controlUnits'],
        UI: { type: 'action', borderRadius: '8px', width: 150, bodyColorS: '#fff', border: '1px solid #e0e0e0', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/useful/notification-bell.png',

        headers: [
            { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}title', placeholder: '{{lang}}title', required: true } },
            // { key: 'userId', type: '', col: '12', information: { label: '{{lang}}user id',  placeholder: '{{lang}}title', required: true } },
            { type: 'GlobalUserInput', key: 'userId', information: { label: '{{lang}}Global User', address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', placeholder: '{{lang}}select', required: false, }, hideComponent: true },

            { key: 'description ', type: 'TextInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: true } },
            { key: 'priority', type: 'TextInput', col: '12', information: { label: '{{lang}}priority', placeholder: '{{lang}}priority', required: true } },
            { key: 'status', type: 'TextInput', col: '12', information: { label: '{{lang}}status', placeholder: '{{lang}}status', required: true } },
            { key: 'project', type: 'TextInput', col: '12', information: { label: '{{lang}}project', placeholder: '{{lang}}project', required: true } },

        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },



    'setVariables': {
        key: 'setVariables',
        title: 'Set Variable',
        group: 'operator',

        parents: ['controlUnits'],

        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/setVariables.svg',
        headers: [
            { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}title', placeholder: '{{lang}}title', required: true } },
            { key: 'applet', type: 'SelectInput', col: '2', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: false } },
            { key: 'id', type: 'TextInput', col: '2', information: { label: '{{lang}}ID', placeholder: '{{lang}}ID', required: false } },
        ],
        defaultNodes: {

            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },



    'timeFilter': {
        key: 'timeFilter',
        title: '{{lang}}time filter',
        group: 'operator',

        parents: ['controlUnits'],

        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/timeFilter.svg',
        headers: [
            { key: 'applet', type: 'SelectInput', col: '2', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: false } },
            { key: 'id', type: 'TextInput', col: '2', information: { label: '{{lang}}ID', placeholder: '{{lang}}ID', required: false } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },


    'manualTrigger': {
        key: 'manualTrigger',
        title: '{{lang}}Manual trigger',
        group: 'trigger',

        parents: ['controlUnits'],

        UI: { type: "trigger", bodyColorE: "#fff", bodyColorS: "#fff", borderRadius: "50%", showIcon: '/assets/icons/forms/number.png', width: 80 },
        icon: '/assets/icons/elements/timeFilter.svg',
        headers: [

            { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}label', placeholder: '{{lang}}insertLabel', required: true } },
            { key: 'description ', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false } },

            { key: 'hasFields', type: 'SwitchInput', col: '2', information: { label: '{{lang}}Needs to receive data will triggered?', hint: '{{lang}}If you turn on this option will this triggered is called, some data can be passed as input data to the automation.', required: false } },

            {
                key: 'data', type: 'TextInput', col: '2', information: { label: '{{lang}}Data name', isVariableName: true, type: 'object', structureFields: 'fields', hint: "{{lang}}This name will be used for referring to this component's output in other parts of diagram. It should be a unique name.", placeholder: '{{lang}}variable', required: true },
                dependencies: [{
                    refKey: 'hasFields', targetKey: 'data',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.hasFields' }, operator: { value: '==' }, target: { value: true } } }, },
                        effect: { show: true, }
                    }],
                    else: { show: false, changeData: { key: 'data', value: null } },
                    init: true,

                }],
            },


            {
                key: 'fields', type: 'FormBuilderInput', col: '2', information: { label: '{{lang}}Dynamic fields', placeholder: '{{lang}}fileds', required: true },
                dependencies: [{
                    refKey: 'hasFields', targetKey: 'fields',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.hasFields' }, operator: { value: '==' }, target: { value: true } } }, },
                        effect: { show: true, }
                    }],
                    else: { show: false },
                    init: true,

                }],
            },

        ],
        defaultNodes: {
            // 'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },



    'timeTrigger': {
        key: 'timeTrigger',
        title: '{{lang}}Time trigger',
        group: 'trigger',

        parents: ['controlUnits'],

        UI: { type: "trigger", bodyColorE: "#fff", bodyColorS: "#fff", borderRadius: "50%", showIcon: '/assets/icons/forms/number.png', width: 80 },

        icon: '/assets/icons/elements/timeFilter.svg',
        headers: [
            { key: 'applet', type: 'SelectInput', col: '2', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: false } },
            { key: 'id', type: 'TextInput', col: '2', information: { label: '{{lang}}ID', placeholder: '{{lang}}ID', required: false } },
        ],
        defaultNodes: {
            // 'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },



    'timeSubscriber': {
        key: 'timeSubscriber',
        title: '{{lang}}Time Subscriber',
        group: 'action',

        parents: ['controlUnits'],

        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/timeFilter.svg',
        headers: [
            { key: 'applet', type: 'SelectInput', col: '2', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: false } },
            { key: 'id', type: 'TextInput', col: '2', information: { label: '{{lang}}ID', placeholder: '{{lang}}ID', required: false } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },



    'wait': {
        key: 'wait',
        title: '{{lang}}Wait',
        group: 'operator',

        parents: ['controlUnits'],

        UI: { type: 'operator', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/wait.svg',
        headers: [
            { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}label', placeholder: '{{lang}}insertLabel', required: true } },
            { key: 'applet', type: 'SelectInput', col: '2', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: false } },
            { key: 'id', type: 'TextInput', col: '2', information: { label: '{{lang}}ID', placeholder: '{{lang}}ID', required: false } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'geoFilter': {
        key: 'geoFilter',
        title: '{{lang}}geo filter',
        group: 'operator',

        parents: ['controlUnits'],

        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/geoFilter.svg',
        headers: [
            { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}label', placeholder: '{{lang}}insertLabel', required: true } },
            { key: 'applet', type: 'SelectInput', col: '2', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: false } },
            { key: 'id', type: 'TextInput', col: '2', information: { label: '{{lang}}ID', placeholder: '{{lang}}ID', required: false } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },


    'runFlow': {
        key: 'runFlow',
        title: 'Run other automation',
        group: 'action',
        parents: ['controlUnits'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/acceptInvitation.svg',
        headers: [
            { key: 'flow', type: 'SelectInput', col: '12', information: { label: '{{lang}}flow', type: 'api', address: 'getAutomations', filter: { applet: '{{appletId}}' }, fields: { title: 'name', value: '_id' }, required: true }, disabled: true },
            {
                key: 'trigger', type: 'SelectInput', col: '12', information: { label: '{{lang}}flow', type: 'api', address: 'getAutomationTriggers', filter: { applet: '{{appletId}}' }, fields: { title: 'title', value: 'key' }, required: true }, disabled: true,
                dependencies: [{
                    refKey: 'flow', targetKey: 'trigger',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.flow' }, operator: { value: '!=' }, target: { value: null } } }, },
                        effect: { show: true, changeHeader: [{ key: 'information.filter._id', value: '@data.flow' }] }
                    }],
                    else: { show: false, changeHeader: [{ key: 'required', value: false }] },
                    init: true,
                    // show:true,

                }]
            },


        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    // 'decisionMaking': {
    //     key: 'decisionMaking',
    //     title: 'decision making',
    //     group: 'operator',
    //     parents: ['controlUnits'],

    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/decisionMaking.svg',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },



    // 'getTimeTracker': {
    //     key: 'getTimeTracker',
    //     title: 'get time tracker',
    //     group: 'operator',
    //     parents: ['controlUnits'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'getArchive': {
    //     key: 'getArchive',
    //     title: 'get archive',
    //     group: 'operator',
    //     parents: ['controlUnits'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    //create
    'onTaskCreate': {
        key: 'onTaskCreate',
        title: 'On Task Create',
        group: 'trigger',
        parents: ['Tasking'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/onTaskCreate.svg',
        headers: [
            { key: 'applet', type: 'SelectInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },


    'onStageChange': {
        key: 'onStageChange',
        title: 'On Stage Change',
        group: 'trigger',
        parents: ['controlUnits'],
        UI: { type: "trigger", bodyColorE: "#fff", bodyColorS: "#fff", borderRadius: "50%", showIcon: '/assets/icons/forms/number.png', width: 80 },
        icon: '/assets/icons/elements/onUpdatedField.svg',
        // UI: { type: 'circle', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        // icon: '/assets/icons/elements/onUploadDriveFile.svg',
        headers: [

            { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}label', placeholder: '{{lang}}insertLabel', required: true } },

            { key: 'frames', helperKey: 'framesRef', type: 'FrameSelectInput', information: { isSearchable: true, multiple: true, label: '{{lang}}Frames', address: 'getFramesApplet', filter: { appletPopulate: true, appletHub: '{{appletHub}}', type: ['collection', 'folder'] }, fields: { title: 'name', value: '_id', image: 'image', mainParent: 'applet', parent: 'parents', type: 'type', mode: 'mode', name: 'name', cDate: 'cDate', applet: 'applet' }, type: 'api', placeholder: '{{lang}}Select frames ...', required: true }, },

            { key: 'allStages', type: 'SwitchInput', col: '2', information: { label: '{{lang}}All stages', default: true, hint: '{{lang}}All stages of the frames are acceptable but if you want to limit to just some stages, you can turn this option off.', required: false } },

            // { key: 'applet', type: 'SelectInput', col: '12', information: { label: '{{lang}}Applet', fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, filter: {}, type: 'api', address: '', placeholder: '{{lang}}Applet', required: true } },
            // { key: 'frame', type: 'SelectInput', col: '12', information: { label: '{{lang}}frame', fields: { title: 'name', value: '_id' }, filter: {}, type: 'api', address: 'getFrames', placeholder: '{{lang}}collection', required: true } },
            {
                key: 'stages', type: 'StagesSelectInput', col: '12', information: { framesKey: 'framesRef', label: '{{lang}}Stages', nameAsValue: true, fields: { title: 'name', value: '_id' }, filter: {}, type: 'api', address: 'getFrames', placeholder: '{{lang}}Select stages', hint: "{{lang}}Stage are listed and will be considered by their name. If stages with same name have different colors, you may see them by the color of one of them.", required: true },
                dependencies: [{
                    refKey: ['allStages', 'framesRef'], targetKey: 'stages',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.allStages' }, operator: { value: '!=' }, target: { value: true } } } },
                        effect: { show: true, changeHeader: [{ key: 'information.frame', value: '@data.framesRef' }] }
                    }],
                    else: { show: false },
                    init: true,

                }]
            },


            { key: 'useVariables', type: 'SwitchInput', col: '2', information: { label: '{{lang}}Use trigger data?', hint: '{{lang}}If you turn on this option will be abled to use trigger data in the flow.', required: false } },

            {
                key: 'dataNewField', type: 'TextInput', col: '2', information: { label: '{{lang}}Data name - New stage name', isVariableName: true, type: 'field', fieldTypes: ['stage'], dynamicStructureFrames: 'frames', hint: "{{lang}}Name of stage after update can be used a variable with this name.", placeholder: '{{lang}}variable', required: false },
                dependencies: [{
                    refKey: 'useVariables', targetKey: 'data_newStage',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.useVariables' }, operator: { value: '==' }, target: { value: true } } }, },
                        effect: { show: true, }
                    }],
                    else: { show: false, changeData: { key: 'data_newStage', value: null } },
                    init: true,

                }],
            },

            {
                key: 'dataOldField', type: 'TextInput', col: '2', information: { label: '{{lang}}Data name - Old stage name', isVariableName: true, type: 'field', fieldTypes: ['stage'], dynamicStructureFrames: 'frames', hint: "{{lang}}Name of stage before update can be used a variable with this name.", placeholder: '{{lang}}variable', required: false },
                dependencies: [{
                    refKey: 'useVariables', targetKey: 'data_oldStage',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.useVariables' }, operator: { value: '==' }, target: { value: true } } }, },
                        effect: { show: true, }
                    }],
                    else: { show: false, changeData: { key: 'data_oldStage', value: null } },
                    init: true,

                }],
            },


            {
                key: 'dataNewRecord', type: 'TextInput', col: '2', information: { label: '{{lang}}Data name - Full new record', isVariableName: true, type: 'record', structureFields: '*dynamic', dynamicStructureFrames: 'frames', hint: "{{lang}}Full record data after update can be used a variable with this name.", placeholder: '{{lang}}variable', required: false },
                dependencies: [{
                    refKey: 'useVariables', targetKey: 'data_newRecord',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.useVariables' }, operator: { value: '==' }, target: { value: true } } }, },
                        effect: { show: true, }
                    }],
                    else: { show: false, changeData: { key: 'data_newRecord', value: null } },
                    init: true,

                }],
            },


            {
                key: 'dataOldRecord', type: 'TextInput', col: '2', information: { label: '{{lang}}Data name - Full old record', isVariableName: true, type: 'record', structureFields: '*dynamic', dynamicStructureFrames: 'frames', hint: "{{lang}}Full record data before update can be used a variable with this name.", placeholder: '{{lang}}variable', required: false },
                dependencies: [{
                    refKey: 'useVariables', targetKey: 'data_oldRecord',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.useVariables' }, operator: { value: '==' }, target: { value: true } } }, },
                        effect: { show: true, }
                    }],
                    else: { show: false, changeData: { key: 'data_oldRecord', value: null } },
                    init: true,

                }],
            },

        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        },
    },


    'createTask': {
        key: 'createTask',
        title: 'Create Task',
        group: 'action',
        parents: ['Tasking'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/createTask.svg',
        headers: [
            { key: 'applet', type: 'SelectInput', col: '12', information: { label: '{{lang}}applet', type: 'api', address: 'getMyAppletList', filter: {}, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}insertLabel', required: true }, disabled: true },
            {
                key: 'frame', type: 'SelectInput', col: '12', information: { label: '{{lang}}frame', type: 'api', address: 'getFrames', filter: { applet: '{{appletId}}' }, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}frame', required: false }, showMain: false,
                dependencies: [{
                    refKey: 'applet',
                    targetKey: 'frame',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: '@data.applet' }, operator: { value: '!=' }, target: { value: null } },
                                // 1: { id: 1, source: { value: '@data.applet' }, operator: { value: '==' }, target: { value: 'frame' } },
                            }
                        },
                    },
                    show: true,
                    init: true,
                    changeHeader: { key: 'information.filter.applet', value: '@data.applet' },
                }],
            },
            { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}title', placeholder: '{{lang}}title', required: true } },
            { key: 'description ', type: 'TextInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: true } },
            { key: 'priority', type: 'SelectInput', col: '12', information: { label: '{{lang}}priority', type: 'local', items: [{ title: 'low', value: 'low' }, { title: 'mid', value: 'mid' }, { title: 'high', value: 'high' }], placeholder: '{{lang}}priority', required: true } },
            {
                key: 'assignee', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}assignee', type: 'api', address: 'searchUser', filter: { applet: '{{appletId}}' }, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, placeholder: '{{lang}}assignee' },
                dependencies: [{
                    refKey: 'applet',
                    targetKey: 'assignee',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: '@data.applet' }, operator: { value: '!=' }, target: { value: null } },
                                // 1: { id: 1, source: { value: '@data.applet' }, operator: { value: '==' }, target: { value: 'frame' } },
                            }
                        },
                    },
                    show: true,
                    init: true,
                    changeHeader: { key: 'information.filter.applet', value: '@data.applet' },
                }],
            },
            {
                key: 'creator', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}creator', type: 'api', address: 'searchUser', filter: { applet: '{{appletId}}' }, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, placeholder: '{{lang}}creator' },
                dependencies: [{
                    refKey: 'applet',
                    targetKey: 'creator',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: '@data.applet' }, operator: { value: '!=' }, target: { value: null } },
                                // 1: { id: 1, source: { value: '@data.applet' }, operator: { value: '==' }, target: { value: 'frame' } },
                            }
                        },
                    },
                    show: true,
                    init: true,
                    changeHeader: { key: 'information.filter.applet', value: '@data.applet' },
                }],
            },
            // { key: 'status', type: 'TextInput', col: '12', information: { label: '{{lang}}status',  placeholder: '{{lang}}status', required: true } },
            // { key: 'project', type: 'TextInput', col: '12', information: { label: '{{lang}}project',  placeholder: '{{lang}}project', required: true } },

        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },

        }
    },

    //remove
    'onTaskRemove': {
        key: 'onTaskRemove',
        title: 'On Task Removed',
        group: 'trigger',
        parents: ['Tasking'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/onTaskRemove.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'removeTask': {
        key: 'removeTask',
        title: 'Remove Task',
        group: 'action',
        parents: ['Tasking'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/removeTask.svg',
        headers: [
            { key: 'field', type: 'TextInput', col: '12', information: { label: '{{lang}}Field', placeholder: '{{lang}}Field', required: true } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },

    //flow
    // 'taskFlowCreated': {
    //     key: 'taskFlowCreated',
    //     title: 'task flow created',
    //     group: 'trigger',
    //     parents: ['Tasking'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
    //     icon: '/assets/icons/useful/notification-bell.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'taskFlowChanged': {
    //     key: 'taskFlowChanged',
    //     title: 'task flow changed',
    //     group: 'trigger',
    //     parents: ['Tasking'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
    //     icon: '/assets/icons/useful/notification-bell.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    'onArchiveTask': {
        key: 'onArchiveTask',
        title: 'On Archive Task',
        group: 'trigger',
        parents: ['Tasking'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/onArchiveTask.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'archiveTask': {
        key: 'archiveTask',
        title: 'Archive Task',
        group: 'action',
        parents: ['Tasking'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/archiveTask.svg',
        headers: [
            { key: 'archive', type: 'TextInput', col: '12', information: { label: '{{lang}}archive', placeholder: '{{lang}}archive', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    // 'stageCompeleted': {
    //     key: 'stageCompeleted',
    //     title: 'stage completed',
    //     group: 'trigger',
    //     parents: ['Tasking'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
    //     icon: '/assets/icons/useful/notification-bell.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'completeStage': {
    //     key: 'completeStage',
    //     title: 'complete stage',
    //     group: 'action',
    //     parents: ['Tasking'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
    //     icon: '/assets/icons/useful/notification-bell.png',
    //     headers: [
    //         { key: 'archive', type: 'TextInput', col: '12', information: { label: '{{lang}}archive',  placeholder: '{{lang}}archive', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    'onDuplicateTask': {
        key: 'onDuplicateTask',
        title: 'On Duplicate Task',
        group: 'trigger',
        parents: ['Tasking'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/onDuplicateTask.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'duplicateTask': {
        key: 'duplicateTask',
        title: 'Duplicate Task',
        group: 'action',
        parents: ['Tasking'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/duplicateTask.svg',
        headers: [
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'onApproveTask': {
        key: 'onApproveTask',
        title: 'On Approve Task',
        group: 'trigger',
        parents: ['Tasking'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/onApproveTask.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'approveTask': {
        key: 'approveTask',
        title: 'Approve Task',
        group: 'action',
        parents: ['Tasking'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/approveTask.svg',
        headers: [
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'onAssignTask': {
        key: 'onAssignTask',
        title: 'On Assign Task',
        group: 'trigger',
        parents: ['Tasking'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/onAssignTask.svg',
        headers: [
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'assignTask': {
        key: 'assignTask',
        title: 'Assign Task',
        group: 'action',
        parents: ['Tasking'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/assignTask.svg',
        headers: [
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },

    //commerce
    'onCreateResource': {
        key: 'onCreateResource',
        title: 'on Create Resource',
        group: 'trigger',
        parents: ['Commerce'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/onCreateResource.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'createResource': {
        key: 'createResource',
        title: 'Create Resource',
        group: 'action',
        parents: ['Commerce'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/createResource.svg',
        headers: [
            { key: 'applet', type: 'SelectInput', col: '12', information: { label: '{{lang}}applet', type: 'api', address: 'getMyAppletList', filter: {}, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}insertLabel', required: true }, disabled: true },
            {
                key: 'frame', type: 'SelectInput', col: '12', information: { label: '{{lang}}frame', type: 'api', address: 'getFrames', filter: { applet: '{{appletId}}' }, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}frame', required: false }, showMain: false,
                dependencies: [{
                    refKey: 'applet',
                    targetKey: 'frame',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: '@data.applet' }, operator: { value: '!=' }, target: { value: null } },
                                // 1: { id: 1, source: { value: '@data.applet' }, operator: { value: '==' }, target: { value: 'frame' } },
                            }
                        },
                    },
                    show: true,
                    init: true,
                    changeHeader: { key: 'information.filter.applet', value: '@data.applet' },
                }],
            },
            { key: 'type', type: 'SelectInput', col: '2', information: { label: '{{lang}}Type', type: 'local', items: [{ title: 'product', value: 'product' }, { title: 'service', value: 'service' }], placeholder: '{{lang}}Type', required: true } },
            { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}Name', required: true } },
            { key: 'description', type: 'TextInput', col: '12', information: { label: '{{lang}}Description', placeholder: '{{lang}}Description', required: true } },
            { key: 'price', type: 'TextInput', col: '12', information: { label: '{{lang}}Price', placeholder: '{{lang}}Price', required: true } },

        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'onResourceRemove': {
        key: 'onResourceRemove',
        title: 'On Resource Remove',
        group: 'trigger',
        parents: ['Commerce'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/onResourceRemove.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'removeResource': {
        key: 'removeResource',
        title: 'Remove Resource',
        group: 'action',
        parents: ['Commerce'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/removeResource.svg',
        headers: [
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'onAddOrder': {
        key: 'onAddOrder',
        title: 'On Add Order',
        group: 'trigger',
        parents: ['Commerce'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/onAddOrder.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'addOrder': {
        key: 'addOrder',
        title: 'Add Order',
        group: 'action',
        parents: ['Commerce'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/addOrder.svg',
        headers: [
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'onVoucherCreated': {
        key: 'onVoucherCreated',
        title: 'On Voucher Created',
        group: 'trigger',
        parents: ['Commerce'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/onVoucherCreated.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'createVoucher': {
        key: 'createVoucher',
        title: 'Create Voucher',
        group: 'action',
        parents: ['Commerce'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/createVoucher.svg',
        headers: [
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'onAddWarehouse': {
        key: 'onAddWarehouse',
        title: 'On Add Warehouse',
        group: 'trigger',
        parents: ['Commerce'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/onAddWarehouse.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'addWarehouse': {
        key: 'addWarehouse',
        title: 'Add Warehouse',
        group: 'action',
        parents: ['Commerce'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/addWarehouse.svg',
        headers: [
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'onLowStock': {
        key: 'onLowStock',
        title: 'On Low Stock',
        group: 'trigger',
        parents: ['Commerce'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/onLowStock.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'onTransferResource': {
        key: 'onTransferResource',
        title: 'On Transfer Resource',
        group: 'trigger',
        parents: ['Commerce'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/onTransferResource.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'transferResource': {
        key: 'transferResource',
        title: 'Transfer Resource',
        group: 'action',
        parents: ['Commerce'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/transferResource.svg',
        headers: [
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'onAdjustResource': {
        key: 'onAdjustResource',
        title: 'On Adjust Resource',
        group: 'trigger',
        parents: ['Commerce'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/onAdjustResource.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'adjustResource': {
        key: 'adjustResource',
        title: 'Adjust Resource',
        group: 'action',
        parents: ['Commerce'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/adjustResource.svg',
        headers: [
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'addDiscount': {
        key: 'addDiscount',
        title: 'Add Discount',
        group: 'action',
        parents: ['Commerce'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/addDiscount.svg',
        headers: [
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    // 'onResourceSell': {
    //     key: 'onResourceSell',
    //     title: 'On Resource Sell',
    //     group: 'trigger',
    //     parents: ['Commerce'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
    //     icon: '/assets/icons/useful/notification-bell.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'sellResource': {
    //     key: 'sellResource',
    //     title: 'sell resource',
    //     group: 'action',
    //     parents: ['Commerce'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
    //     icon: '/assets/icons/useful/notification-bell.png',
    //     headers: [
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    // 'onResourceCancel': {
    //     key: 'onResourceCancel',
    //     title: 'On Resource Cancel',
    //     group: 'trigger',
    //     parents: ['Commerce'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
    //     icon: '/assets/icons/useful/notification-bell.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'cancelResource': {
    //     key: 'cancelResource',
    //     title: 'cancel resource',
    //     group: 'action',
    //     parents: ['Commerce'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
    //     icon: '/assets/icons/useful/notification-bell.png',
    //     headers: [
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    // 'resourceCancelled': {
    //     key: 'resourceCancelled',
    //     title: 'resource cancelled',
    //     group: 'trigger',
    //     parents: ['Commerce'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
    //     icon: '/assets/icons/useful/notification-bell.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'cancellResource': {
    //     key: 'cancellResource',
    //     title: 'cancell resource',
    //     group: 'action',
    //     parents: ['Commerce'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
    //     icon: '/assets/icons/useful/notification-bell.png',
    //     headers: [
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    // 'availabilityChanged': {
    //     key: 'availabilityChanged',
    //     title: 'Availiability Changed',
    //     group: 'trigger',
    //     parents: ['Commerce'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
    //     icon: '/assets/icons/useful/notification-bell.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'changeAvailability': {
    //     key: 'changeAvailability',
    //     title: 'change availability',
    //     group: 'action',
    //     parents: ['Commerce'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
    //     icon: '/assets/icons/useful/notification-bell.png',
    //     headers: [
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    'onCategoryCreate': {
        key: 'onCategoryCreate',
        title: 'On Category Create',
        group: 'trigger',
        parents: ['Commerce'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/onCategoryCreate.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'createCategory': {
        key: 'createCategory',
        title: 'Create Category',
        group: 'action',
        parents: ['Commerce'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/createCategory.svg',
        headers: [
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    // 'categoryChanged': {
    //     key: 'categoryChanged',
    //     title: 'category changed',
    //     group: 'trigger',
    //     parents: ['Commerce'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
    //     icon: '/assets/icons/useful/notification-bell.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'changeCategory': {
    //     key: 'changeCategory',
    //     title: 'change category',
    //     group: 'action',
    //     parents: ['Commerce'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
    //     icon: '/assets/icons/useful/notification-bell.png',
    //     headers: [
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    //financial
    'submitPayment': {
        key: 'submitPayment',
        title: '{{lang}}submit payment',
        group: 'action',
        // UI: { type: 'circle', borderRadius: '50%', width: 120, bodyColor: '#D098A5', bodyColorS: '#93A8D0', bodyColorE: '#A3ABBD', showIcon: 'https://www.flaticon.com/svg/static/icons/svg/3036/3036996.svg' },
        UI: { type: 'circle', borderRadius: '50%', width: 80, bodyColorS: '#4B5CF1', bodyColorE: '#7B51F1', showIcon: '/assets/icons/useful/notification-bell.png' },

        parents: ['Finance'],
        icon: '/assets/icons/elements/submitPayment.svg',
        headers: [
            { key: 'applet', type: 'SelectInput', col: '12', information: { label: '{{lang}}Applet', fields: { title: 'test' }, placeholder: '{{lang}}insertLabel', required: true } },
            { key: 'frame', type: 'SelectInput', col: '12', information: { label: '{{lang}}Frame', fields: { title: 'test' }, placeholder: '{{lang}}insertLabel', required: true } },
            { key: 'payment', type: 'SelectInput', col: '12', information: { label: '{{lang}}Payment', fields: { title: 'test' }, placeholder: '{{lang}}insertLabel', required: true } },
        ],

        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'onPaymentSubmit': {
        key: 'onPaymentSubmit',
        title: '{{lang}}on payment submit',
        group: 'trigger',
        // UI: { type: 'circle', borderRadius: '50%', width: 120, bodyColor: '#D098A5', bodyColorS: '#93A8D0', bodyColorE: '#A3ABBD', showIcon: 'https://www.flaticon.com/svg/static/icons/svg/3036/3036996.svg' },
        UI: { type: 'circle', borderRadius: '50%', width: 80, bodyColorS: '#4B5CF1', bodyColorE: '#7B51F1', showIcon: '/assets/icons/useful/notification-bell.png' },

        parents: ['Finance'],
        icon: '/assets/icons/elements/onPaymentSubmit.svg',
        headers: [
            { key: 'applet', type: 'SelectInput', col: '12', information: { label: '{{lang}}Applet', fields: { title: 'test' }, placeholder: '{{lang}}insertLabel', required: true } },
            { key: 'frame', type: 'SelectInput', col: '12', information: { label: '{{lang}}Frame', fields: { title: 'test' }, placeholder: '{{lang}}insertLabel', required: true } },
            { key: 'payment', type: 'SelectInput', col: '12', information: { label: '{{lang}}Payment', fields: { title: 'test' }, placeholder: '{{lang}}insertLabel', required: true } },
        ],

        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'submitInvoice': {
        key: 'submitInvoice',
        title: '{{lang}}submit invoice',
        group: 'action',
        // UI: { type: 'circle', borderRadius: '50%', width: 120, bodyColor: '#D098A5', bodyColorS: '#93A8D0', bodyColorE: '#A3ABBD', showIcon: 'https://www.flaticon.com/svg/static/icons/svg/3036/3036996.svg' },
        UI: { type: 'circle', borderRadius: '50%', width: 80, bodyColorS: '#4B5CF1', bodyColorE: '#7B51F1', showIcon: '/assets/icons/useful/notification-bell.png' },

        parents: ['Finance'],
        icon: '/assets/icons/elements/submitInvoice.svg',
        headers: [
            { key: 'selectInvoice', type: 'SelectInput', col: '12', information: { label: '{{lang}}label', fields: { title: 'test' }, placeholder: '{{lang}}insertLabel', required: true } },
        ],

        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'onSubmitInvoice': {
        key: 'onSubmitInvoice',
        title: '{{lang}}on submit invoice',
        group: 'trigger',
        // UI: { type: 'circle', borderRadius: '50%', width: 120, bodyColor: '#D098A5', bodyColorS: '#93A8D0', bodyColorE: '#A3ABBD', showIcon: 'https://www.flaticon.com/svg/static/icons/svg/3036/3036996.svg' },
        UI: { type: 'circle', borderRadius: '50%', width: 80, bodyColorS: '#4B5CF1', bodyColorE: '#7B51F1', showIcon: '/assets/icons/useful/notification-bell.png' },

        parents: ['Finance'],
        icon: '/assets/icons/elements/onSubmitInvoice.svg',
        headers: [
            { key: 'selectInvoice', type: 'SelectInput', col: '12', information: { label: '{{lang}}label', fields: { title: 'test' }, placeholder: '{{lang}}insertLabel', required: true } },
        ],

        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },


    //messenger

    //flowControl
    // 'getUsers': {
    //     key: 'getUsers',
    //     title: 'get user',
    //     group: 'operator',
    //     parents: ['controlUnits'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
    //     icon: '/assets/icons/useful/notification-bell.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'getTopics': {
    //     key: 'getTopics',
    //     title: 'get topics',
    //     group: 'operator',
    //     parents: ['controlUnits'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
    //     icon: '/assets/icons/useful/notification-bell.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'getUserStatus': {
    //     key: 'getUserStatus',
    //     title: 'get user status',
    //     group: 'operator',
    //     parents: ['controlUnits'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
    //     icon: '/assets/icons/useful/notification-bell.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'getStatistics': {
    //     key: 'getStatistics',
    //     title: 'get statistics',
    //     group: 'operator',
    //     parents: ['controlUnits'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
    //     icon: '/assets/icons/useful/notification-bell.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    //trigger-action
    'onSendMessage': {
        key: 'onSendMessage',
        title: 'On Send Message',
        group: 'trigger',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/onSendMessage.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'sendMessage': {
        key: 'sendMessage',
        title: 'send message',
        group: 'action',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/sendMessage.svg',
        headers: [
            { key: 'applet', type: 'SelectInput', col: '12', information: { label: '{{lang}}applet', type: 'api', address: 'getMyAppletList', filter: {}, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}insertLabel', required: true }, disabled: true },
            { key: 'type', type: 'SelectInput', col: '12', information: { label: '{{lang}}type', type: 'local', items: [{ value: 'variable', title: 'send variable' }, { value: 'collectionMessage', title: 'send collection info' }, { value: 'custom', title: 'send custom message' }], filter: {}, fields: { title: 'title', value: 'value' }, required: true }, disabled: true },

            {
                key: 'variable', type: 'SelectInput', col: '12', information: { label: '{{lang}}variable', type: 'api', address: 'getVariables', filter: { applet: '{{appletId}}' }, fields: { title: 'title', value: '_id' }, required: true },
                dependencies: [{
                    refKey: 'type', targetKey: 'variable',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'variable' } } } },
                        effect: { changeHeader: [{ key: 'disabled', value: false }, { key: 'information.required', value: true }], show: true }
                    }],
                    else: { changeHeader: [{ key: 'disabled', value: true }, { key: 'information.required', value: false }], show: false },
                    // init: true,
                    show: true,

                }], disabled: false
            },
            {
                key: 'frame', type: 'SelectInput', col: '12', information: { label: '{{lang}}collection', type: 'api', address: 'getFrames', filter: { applet: '{{appletId}}' }, fields: { title: 'name', value: '_id' }, required: true },
                dependencies: [{
                    refKey: 'type', targetKey: 'frame',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'collectionMessage' } } } },
                        effect: { changeHeader: [{ key: 'disabled', value: false }, { key: 'information.required', value: true }], show: true }
                    }],
                    else: { changeHeader: [{ key: 'disabled', value: true }, { key: 'information.required', value: false }], changeValue: true, show: false },
                    // init: true,
                    show: true,

                }], disabled: false
            },

            {
                key: 'fields', type: 'SelectInput', information: { label: '{{lang}}Choose Filed', type: 'api', address: 'getFrameFields', filter: { _id: "{{frame}}" }, fields: { title: 'information.label', value: 'key' }, required: true, fetchKey: 'fields' },
                dependencies: [{
                    refKey: 'frame', targetKey: 'fields',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.frame' }, operator: { value: '!=' }, target: { value: null } } }, },
                        effect: { changeHeader: [{ key: 'disabled', value: false }, { key: 'information.required', value: true }], show: true }
                    }],
                    else: { changeHeader: [{ key: 'disabled', value: true }, { key: 'information.required', value: false }], changeValue: true, show: false },
                    init: true,
                    // show:true,

                }], disabled: false
            },
            {
                key: 'text', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}message', required: true },
                dependencies: [{
                    refKey: 'type', targetKey: 'text',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'custom' } } } },
                        effect: { changeHeader: [{ key: 'disabled', value: false }, { key: 'information.required', value: true }], show: true }
                    }],
                    else: { changeHeader: [{ key: 'disabled', value: true }, { key: 'information.required', value: false }], show: false },
                    // init: true,
                    show: true,

                }], disabled: false

            },

            { key: 'potentialApplet', type: 'SelectInput', col: '12', information: { label: '{{lang}}Send to', type: 'api', address: 'getMessengerApplets', filter: {}, fields: { title: 'hub.fullname', value: '_id' }, required: true } },


            // { key: 'message', type: 'TextInput', col: '12', information: { label: '{{lang}}Message',  placeholder: '{{lang}}Message', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'onReceiveMessage': {
        key: 'onReceiveMessage',
        title: 'On Receive Message',
        group: 'trigger',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/onReceiveMessage.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    // 'receiveMessage': {
    //     key: 'receiveMessage',
    //     title: 'receive message',
    //     group: 'action',
    //     parents: ['Messenger'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
    //     icon: '/assets/icons/useful/notification-bell.png',
    //     headers: [
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    'onRemoveMessage': {
        key: 'onRemoveMessage',
        title: 'On Remove Message',
        group: 'trigger',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/onRemoveMessage.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'removeMessage': {
        key: 'removeMessage',
        title: 'Remove Message',
        group: 'action',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/removeMessage.svg',
        headers: [
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'onEditmessage': {
        key: 'onEditmessage',
        title: 'on Edit message',
        group: 'trigger',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/onEditmessage.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'editMessage': {
        key: 'editMessage',
        title: 'Edit Message',
        group: 'action',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/editMessage.svg',
        headers: [
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'onPinMessage': {
        key: 'onPinMessage',
        title: 'on Pin Message',
        group: 'trigger',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/onPinMessage.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'pinMessage': {
        key: 'pinMessage',
        title: 'Pin Message',
        group: 'action',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/pinMessage.svg',
        headers: [
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'onReplyMessage': {
        key: 'onReplyMessage',
        title: 'On Reply Message',
        group: 'trigger',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/onReplyMessage.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'replyMessage': {
        key: 'replyMessage',
        title: 'Reply Message',
        group: 'action',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/replyMessage.svg',
        headers: [
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'sendReaction': {
        key: 'sendReaction',
        title: 'Send Reaction',
        group: 'action',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/sendReaction.svg',
        headers: [
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    // 'fileSent': {
    //     key: 'fileSent',
    //     title: 'file sent',
    //     group: 'trigger',
    //     parents: ['Messenger'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
    //     icon: '/assets/icons/useful/notification-bell.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'sendFile': {
    //     key: 'sendFile',
    //     title: 'send file',
    //     group: 'action',
    //     parents: ['Messenger'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
    //     icon: '/assets/icons/useful/notification-bell.png',
    //     headers: [
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    'onSeenMessage': {
        key: 'onSeenMessage',
        title: 'On Seen Message',
        group: 'trigger',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/onSeenMessage.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'seenMessage': {
        key: 'seenMessage',
        title: 'seen message',
        group: 'action',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/seenMessage.svg',
        headers: [
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },

    'onRemoveMessenger': {
        key: 'onRemoveMessenger',
        title: 'on Remove Messenger',
        group: 'trigger',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/onRemoveMessenger.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'removeMessenger': {
        key: 'removeMessenger',
        title: 'remove messenger',
        group: 'action',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/removeMessenger.svg',
        headers: [
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'onMuteMessenger': {
        key: 'onMuteMessenger',
        title: 'On Mute Messenger',
        group: 'trigger',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/onMuteMessenger.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'muteMessenger': {
        key: 'muteMessenger',
        title: 'mute messenger',
        group: 'action',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/muteMessenger.svg',
        headers: [
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'onPinMessenger': {
        key: 'onPinMessenger',
        title: 'On Pin Messenger',
        group: 'trigger',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/onPinMessage.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'pinMessenger': {
        key: 'pinMessenger',
        title: 'pin messenger',
        group: 'action',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/pinMessage.svg',
        headers: [
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    // 'userStatusChanged': {
    //     key: 'userStatusChanged',
    //     title: 'user status changed',
    //     group: 'trigger',
    //     parents: ['Messenger'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
    //     icon: '/assets/icons/useful/notification-bell.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'changeUserStatus': {
    //     key: 'changeUserStatus',
    //     title: 'change user status',
    //     group: 'action',
    //     parents: ['Messenger'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
    //     icon: '/assets/icons/useful/notification-bell.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    // 'typingChanged': {
    //     key: 'typingChanged',
    //     title: 'typing changed',
    //     group: 'trigger',
    //     parents: ['Messenger'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
    //     icon: '/assets/icons/useful/notification-bell.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    'onCreateMessenger': {
        key: 'onCreateMessenger',
        title: 'On Create Messenger',
        group: 'trigger',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/onCreateMessenger.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'createMessenger': {
        key: 'createMessenger',
        title: 'Create Messenger',
        group: 'action',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/createMessenger.svg',
        headers: [
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    // 'messengerSearched': {
    //     key: 'messengerSearched',
    //     title: 'messenger searched',
    //     group: 'trigger',
    //     parents: ['Messenger'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
    //     icon: '/assets/icons/useful/notification-bell.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'searchMessenger': {
    //     key: 'searchMessenger',
    //     title: 'search messenger',
    //     group: 'action',
    //     parents: ['Messenger'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
    //     icon: '/assets/icons/useful/notification-bell.png',
    //     headers: [
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    // 'messengerSettingUpdated': {
    //     key: 'messengerSettingUpdated',
    //     title: 'setting updated',
    //     group: 'trigger',
    //     parents: ['Messenger'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
    //     icon: '/assets/icons/useful/notification-bell.png',
    //     headers: [
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    'onSendInvitation': {
        key: 'onSendInvitation',
        title: 'On Send Invitation',
        group: 'trigger',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/onSendInvitation.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'sendInvitation': {
        key: 'sendInvitation',
        title: 'send invitation',
        group: 'action',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/sendInvitation.svg',
        headers: [
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'onAcceptInvitation': {
        key: 'onAcceptInvitation',
        title: 'On Accept Invitation',
        group: 'trigger',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/onAcceptInvitation.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'acceptInvitation': {
        key: 'acceptInvitation',
        title: 'Accept Invitation',
        group: 'action',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/acceptInvitation.svg',
        headers: [
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },

    'onDeclineInvitation': {
        key: 'onDeclineInvitation',
        title: 'On Decline Invitation',
        group: 'trigger',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/onDeclineInvitation.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'declineInvitation': {
        key: 'declineInvitation',
        title: 'decline invitation',
        group: 'action',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/declineInvitation.svg',
        headers: [
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    // 'updatePermission': {
    //     key: 'updatePermission',
    //     title: 'update permission',
    //     group: 'action',
    //     parents: ['Messenger'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
    //     icon: '/assets/icons/useful/notification-bell.png',
    //     headers: [
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    'addMention': {
        key: 'addMention',
        title: 'add mention',
        group: 'action',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/addMention.svg',
        headers: [
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'onCreateUser': {
        key: 'onCreateUser',
        title: 'on CreateUser',
        group: 'trigger',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/onCreateUser.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'createUser': {
        key: 'createUser',
        title: 'create user',
        group: 'action',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/createUser.svg',
        headers: [
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'userBlocked': {
        key: 'userBlocked',
        title: 'user blocked',
        group: 'trigger',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/userBlocked.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'blockUser': {
        key: 'blockUser',
        title: 'block user',
        group: 'action',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/blockUser.svg',
        headers: [
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'userKicked': {
        key: 'userKicked',
        title: 'user kicked',
        group: 'trigger',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/userKicked.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'kickUser': {
        key: 'kickUser',
        title: 'kick user',
        group: 'action',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/kickUser.svg',
        headers: [
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'userTimeout': {
        key: 'userTimeout',
        title: 'user timeout',
        group: 'trigger',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/userTimeout.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'timeoutUser': {
        key: 'timeoutUser',
        title: 'timeout user',
        group: 'action',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/timeoutUser.svg',
        headers: [
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'topicCreated': {
        key: 'topicCreated',
        title: 'topic created',
        group: 'trigger',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/topicCreated.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'createTopic': {
        key: 'createTopic',
        title: 'create topic',
        group: 'action',
        parents: ['Messenger'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/createTopic.svg',
        headers: [
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },

    //booking
    //flowcontrol
    // 'getStatus': {
    //     key: 'getStatus',
    //     title: 'get status',
    //     group: 'operator',
    //     parents: ['controlUnits'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
    //     icon: '/assets/icons/useful/notification-bell.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'getBooking': {
    //     key: 'getBooking',
    //     title: 'get booking',
    //     group: 'operator',
    //     parents: ['controlUnits'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
    //     icon: '/assets/icons/useful/notification-bell.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'getBookings': {
    //     key: 'getBookings',
    //     title: 'get all booking',
    //     group: 'operator',
    //     parents: ['controlUnits'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
    //     icon: '/assets/icons/useful/notification-bell.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'getCount': {
    //     key: 'getCount',
    //     title: 'get count',
    //     group: 'operator',
    //     parents: ['controlUnits'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
    //     icon: '/assets/icons/useful/notification-bell.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'getPrice': {
    //     key: 'getPrice',
    //     title: 'get price',
    //     group: 'operator',
    //     parents: ['controlUnits'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
    //     icon: '/assets/icons/useful/notification-bell.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    //trigger-action
    'onAppointmentCreate': {
        key: 'onAppointmentCreate',
        title: 'on appointment create',
        group: 'trigger',
        parents: ['Booking'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/onAppointmentCreate.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'createAppointment': {
        key: 'createAppointment',
        title: 'create appointment',
        group: 'action',
        parents: ['Booking'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/createAppointment.svg',
        headers: [
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'onAppointmentapproved': {
        key: 'onAppointmentapproved',
        title: 'on appointment approved',
        group: 'trigger',
        parents: ['Booking'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/onAppointmentapproved.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'approveAppointment': {
        key: 'approveAppointment',
        title: 'approve appointment',
        group: 'action',
        parents: ['Booking'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/useful/notification-bell.png' },
        icon: '/assets/icons/elements/approveAppointment.svg',
        headers: [
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'onAppointmentCancel': {
        key: 'onAppointmentCancel',
        title: 'on appointment cancel',
        group: 'trigger',
        parents: ['Booking'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/onAppointmentCancel.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'cancelAppointment': {
        key: 'cancelAppointment',
        title: 'cancel appointment',
        group: 'action',
        parents: ['Booking'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/cancelAppointment.svg',
        headers: [
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    // 'appointmentChanged': {
    //     key: 'appointmentChanged',
    //     title: 'appointment changed',
    //     group: 'trigger',
    //     parents: ['Booking'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'changeAppointment': {
    //     key: 'changeAppointment',
    //     title: 'change appointment',
    //     group: 'action',
    //     parents: ['Booking'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    'onAppointmentComplete': {
        key: 'onAppointmentComplete',
        title: 'on appointment complete',
        group: 'trigger',
        parents: ['Booking'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/onAppointmentComplete.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'completeAppointment': {
        key: 'completeAppointment',
        title: 'complete appointment',
        group: 'action',
        parents: ['Booking'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/completeAppointment.svg',
        headers: [
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },

    //developers
    //trigger-action
    'sendOnWebhook': {
        key: 'sendOnWebhook',
        title: 'Send On Webhook',
        group: 'action',
        parents: ['controlUnits'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/webhook.svg',
        headers: [
            { key: 'dataStructure', type: 'SelectInput', col: '12', information: { label: '{{lang}}dataStructure', placeholder: '{{lang}}dataStructure', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'onReceiveWebhook': {
        key: 'onReceiveWebhook',
        title: 'Data From Webhook',
        group: 'trigger',
        parents: ['controlUnits'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/webhook2.svg',
        headers: [
            { key: 'dataStructure', type: 'SelectInput', col: '12', information: { label: '{{lang}}dataStructure', placeholder: '{{lang}}dataStructure', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    //sequence
    //flowcontrol
    //trigger-action
    // 'sequenceDataSent': {
    //     key: 'sequenceDataSent',
    //     title: 'sequence data sent',
    //     group: 'trigger',
    //     parents: ['sequence'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'sendSequenceData': {
    //     key: 'sendSequenceData',
    //     title: 'send sequence data',
    //     group: 'action',
    //     parents: ['sequence'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },

    //drive
    //flowcontrol
    // 'getFolderInfo': {
    //     key: 'getFolderInfo',
    //     title: 'get folder info',
    //     group: 'operator',
    //     parents: ['controlUnits'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'getFolderContentInfo': {
    //     key: 'getFolderContentInfo',
    //     title: 'get folder content info',
    //     group: 'operator',
    //     parents: ['controlUnits'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'getAddressFile': {
    //     key: 'getAddressFile',
    //     title: 'get address',
    //     group: 'operator',
    //     parents: ['controlUnits'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'getSeenCount': {
    //     key: 'getSeenCount',
    //     title: 'get seen count',
    //     group: 'operator',
    //     parents: ['controlUnits'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    //trigger-action
    'onUploadDriveFile': {
        key: 'onUploadDriveFile',
        title: 'on Upload File',
        group: 'trigger',
        parents: ['Drive'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/onUploadDriveFile.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'uploadDriveFile': {
        key: 'uploadDriveFile',
        title: 'Upload File',
        group: 'action',
        parents: ['Drive'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/uploadDriveFile.svg',
        headers: [
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'onDownloadDriveFile': {
        key: 'onDownloadDriveFile',
        title: 'On Download File',
        group: 'trigger',
        parents: ['Drive'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/onDownloadDriveFile.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'downloadDriveFile': {
        key: 'downloadDriveFile',
        title: 'Download File',
        group: 'action',
        parents: ['Drive'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/downloadDriveFile.svg',
        headers: [
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'onRemoveDriveFile': {
        key: 'onRemoveDriveFile',
        title: 'on Remove File',
        group: 'trigger',
        parents: ['Drive'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/onRemoveDriveFile.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'removeDriveFile': {
        key: 'removeDriveFile',
        title: 'Remove File',
        group: 'action',
        parents: ['Drive'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/removeDriveFile.svg',
        headers: [
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'driveFileRenamed': {
        key: 'driveFileRenamed',
        title: 'file renamed',
        group: 'trigger',
        parents: ['Drive'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/driveFileRenamed.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'driveRenameFile': {
        key: 'driveRenameFile',
        title: 'rename file',
        group: 'action',
        parents: ['Drive'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/driveRenameFile.svg',
        headers: [
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'driveNewFolderCreated': {
        key: 'driveNewFolderCreated',
        title: 'New folder created',
        group: 'trigger',
        parents: ['Drive'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/driveNewFolderCreated.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'driveCreateNewFolder': {
        key: 'driveCreateNewFolder',
        title: 'Create new folder',
        group: 'action',
        parents: ['Drive'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/driveCreateNewFolder.svg',
        headers: [
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'createShortcut': {
        key: 'createShortcut',
        title: 'create shortcut',
        group: 'action',
        parents: ['Drive'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/createShortcut.svg',
        headers: [
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'copy': {
        key: 'copy',
        title: 'copy',
        group: 'action',
        parents: ['Drive'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/copy.svg',
        headers: [
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'cut': {
        key: 'cut',
        title: 'cut',
        group: 'action',
        parents: ['Drive'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/cut.svg',
        headers: [
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'driveTag': {
        key: 'driveTag',
        title: 'tag',
        group: 'action',
        parents: ['Drive'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/driveTag.svg',
        headers: [
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'driveSearched': {
        key: 'driveSearched',
        title: 'drive searched',
        group: 'trigger',
        parents: ['Drive'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/driveSearched.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'driveSearch': {
        key: 'driveSearch',
        title: 'search',
        group: 'action',
        parents: ['Drive'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/driveSearch.svg',
        headers: [
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },

    //database
    'onDatabaseStageChanges': {
        key: 'onDatabaseStageChanges',
        title: 'On Database Stage Changes',
        group: 'trigger',
        parents: ['Database'],
        UI: { type: 'circle', borderRadius: '50%', width: 80, bodyColorS: '#4B5CF1', bodyColorE: '#7B51F1', showIcon: '/assets/icons/elements/number.png' },
        // UI: { type: 'circle', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/onDatabaseStageChanges.svg',
        headers: [
            { key: 'applet', type: 'SelectInput', col: '12', information: { label: '{{lang}}Applet', fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, filter: {}, type: 'api', address: '', placeholder: '{{lang}}Applet', required: true } },
            { key: 'frame', type: 'SelectInput', col: '12', information: { label: '{{lang}}frame', fields: { title: 'name', value: '_id' }, filter: {}, type: 'api', address: 'getFrames', placeholder: '{{lang}}collection', required: true } },
            { key: 'stage', type: 'SelectInput', col: '12', information: { label: '{{lang}}stage', fields: { title: 'name', value: '_id' }, filter: {}, type: 'api', address: 'getFrames', placeholder: '{{lang}}collection', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        },
    },
    'changeDatabaseStage': {
        key: 'changeDatabaseStage',
        title: 'Change Database Stage',
        group: 'action',
        parents: ['Database'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/changeDatabaseStage.svg',
        headers: [
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'removedFromDatabase': {
        key: 'removedFromDatabase',
        title: 'data removed',
        group: 'trigger',
        parents: ['Database'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/removedFromDatabase.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'removeFromDatabase': {
        key: 'removeFromDatabase',
        title: 'remove data',
        group: 'action',
        parents: ['Database'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/removeFromDatabase.svg',
        headers: [
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'createdOnDatabase': {
        key: 'createdOnDatabase',
        title: 'data created',
        group: 'trigger',
        parents: ['Database'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/createdOnDatabase.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'createOnDatabase': {
        key: 'createOnDatabase',
        title: 'create data',
        group: 'action',
        parents: ['Database'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/createOnDatabase.svg',
        headers: [
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'databaseDeleted': {
        key: 'databaseDeleted',
        title: 'database deleted',
        group: 'trigger',
        parents: ['Database'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/databaseDeleted.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'deleteDatabase': {
        key: 'deleteDatabase',
        title: 'delete database',
        group: 'action',
        parents: ['Database'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/deleteDatabase.svg',
        headers: [
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    //rooms
    //flowcontrol
    // 'getRooms': {
    //     key: 'getRooms',
    //     title: 'get rooms',
    //     group: 'operator',
    //     parents: ['controlUnits'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'getRoomUsers': {
    //     key: 'getRoomUsers',
    //     title: 'get room users',
    //     group: 'operator',
    //     parents: ['controlUnits'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'getRoomMessages': {
    //     key: 'getRoomMessages',
    //     title: 'get room messages',
    //     group: 'operator',
    //     parents: ['controlUnits'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    //trigger-action
    'roomJoined': {
        key: 'roomJoined',
        title: 'room joined',
        group: 'trigger',
        parents: ['Rooms'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'joinRoom': {
        key: 'joinRoom',
        title: 'join room',
        group: 'action',
        parents: ['Rooms'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'room', type: 'TextInput', col: '12', information: { label: '{{lang}}Room', placeholder: '{{lang}}Room', required: true } },
            { key: 'user', type: 'TextInput', col: '12', information: { label: '{{lang}}User', placeholder: '{{lang}}User', required: true } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'roomRequestReceived': {
        key: 'roomRequestReceived',
        title: 'room request received',
        group: 'trigger',
        parents: ['Rooms'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'roomReceiveRequest': {
        key: 'roomReceiveRequest',
        title: 'room received request',
        group: 'action',
        parents: ['Rooms'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'room', type: 'TextInput', col: '12', information: { label: '{{lang}}Room', placeholder: '{{lang}}Room', required: true } },
            { key: 'user', type: 'TextInput', col: '12', information: { label: '{{lang}}User', placeholder: '{{lang}}User', required: true } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'roomRequestAccepted': {
        key: 'roomRequestAccepted',
        title: 'room request accepted',
        group: 'trigger',
        parents: ['Rooms'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'acceptRoomRequest': {
        key: 'acceptRoomRequest',
        title: 'accept room request',
        group: 'action',
        parents: ['Rooms'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'room', type: 'TextInput', col: '12', information: { label: '{{lang}}Room', placeholder: '{{lang}}Room', required: true } },
            { key: 'user', type: 'TextInput', col: '12', information: { label: '{{lang}}User', placeholder: '{{lang}}User', required: true } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'roomRequestDeclined': {
        key: 'roomRequestDeclined',
        title: 'room request declined',
        group: 'trigger',
        parents: ['Rooms'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'declineRoomRequest': {
        key: 'declineRoomRequest',
        title: 'decline room request',
        group: 'action',
        parents: ['Rooms'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'room', type: 'TextInput', col: '12', information: { label: '{{lang}}Room', placeholder: '{{lang}}Room', required: true } },
            { key: 'user', type: 'TextInput', col: '12', information: { label: '{{lang}}User', placeholder: '{{lang}}User', required: true } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'roomRequestSent': {
        key: 'roomRequestSent',
        title: 'room request sent',
        group: 'trigger',
        parents: ['Rooms'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'roomSendRequest': {
        key: 'roomSendRequest',
        title: 'room send request',
        group: 'action',
        parents: ['Rooms'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'room', type: 'TextInput', col: '12', information: { label: '{{lang}}Room', placeholder: '{{lang}}Room', required: true } },
            { key: 'user', type: 'TextInput', col: '12', information: { label: '{{lang}}User', placeholder: '{{lang}}User', required: true } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'roomMuted': {
        key: 'roomMuted',
        title: 'room muted',
        group: 'trigger',
        parents: ['Rooms'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'muteRoom': {
        key: 'muteRoom',
        title: 'mute room',
        group: 'action',
        parents: ['Rooms'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'room', type: 'TextInput', col: '12', information: { label: '{{lang}}Room', placeholder: '{{lang}}Room', required: true } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'userMuted': {
        key: 'userMuted',
        title: 'user muted',
        group: 'trigger',
        parents: ['Rooms'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'muteUser': {
        key: 'muteUser',
        title: 'mute user',
        group: 'action',
        parents: ['Rooms'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'user', type: 'TextInput', col: '12', information: { label: '{{lang}}User', placeholder: '{{lang}}User', required: true } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'sharedScreen': {
        key: 'sharedScreen',
        title: 'screen shared',
        group: 'trigger',
        parents: ['Rooms'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'screenShare': {
        key: 'screenShare',
        title: 'screen share',
        group: 'action',
        parents: ['Rooms'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'screenshotCaptured': {
        key: 'screenshotCaptured',
        title: 'screenshot captured',
        group: 'trigger',
        parents: ['Rooms'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'captureScreenshot': {
        key: 'captureScreenshot',
        title: 'capture screenshot',
        group: 'action',
        parents: ['Rooms'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'videoCaptured': {
        key: 'videoCaptured',
        title: 'video captured',
        group: 'trigger',
        parents: ['Rooms'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'captureVideo': {
        key: 'captureVideo',
        title: 'capture video',
        group: 'action',
        parents: ['Rooms'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'cameraTurnedOff': {
        key: 'cameraTurnedOff',
        title: 'camera turned off',
        group: 'trigger',
        parents: ['Rooms'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'cameraTurnOff': {
        key: 'cameraTurnOff',
        title: 'camera turn off',
        group: 'action',
        parents: ['Rooms'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'cameraTurnedOn': {
        key: 'cameraTurnedOn',
        title: 'camera turned on',
        group: 'trigger',
        parents: ['Rooms'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'cameraTurnOn': {
        key: 'cameraTurnOn',
        title: 'camera turn on',
        group: 'action',
        parents: ['Rooms'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'roomScheduled': {
        key: 'roomScheduled',
        title: 'room scheduled',
        group: 'trigger',
        parents: ['Rooms'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'scheduleRoom': {
        key: 'scheduleRoom',
        title: 'schedule room',
        group: 'action',
        parents: ['Rooms'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'date', type: 'DateInput', col: '12', information: { label: '{{lang}}Date', placeholder: '{{lang}}Date', required: true } },
            { key: 'repeat', type: 'DateInput', col: '12', information: { label: '{{lang}}Repeat', placeholder: '{{lang}}Repeat', required: true } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'userinvited': {
        key: 'userinvited',
        title: 'user invited',
        group: 'trigger',
        parents: ['Rooms'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'inviteUser': {
        key: 'inviteUser',
        title: 'invite user',
        group: 'action',
        parents: ['Rooms'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'room', type: 'TextInput', col: '12', information: { label: '{{lang}}Room', placeholder: '{{lang}}Room', required: true } },
            { key: 'user', type: 'TextInput', col: '12', information: { label: '{{lang}}User', placeholder: '{{lang}}User', required: true } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'userKicked': {
        key: 'userKicked',
        title: 'user kicked',
        group: 'trigger',
        parents: ['Rooms'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'kickUser': {
        key: 'kickUser',
        title: 'kick user',
        group: 'action',
        parents: ['Rooms'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'room', type: 'TextInput', col: '12', information: { label: '{{lang}}Room', placeholder: '{{lang}}Room', required: true } },
            { key: 'user', type: 'TextInput', col: '12', information: { label: '{{lang}}User', placeholder: '{{lang}}User', required: true } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'roomCreated': {
        key: 'roomCreated',
        title: 'room created',
        group: 'trigger',
        parents: ['Rooms'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'createRoom': {
        key: 'createRoom',
        title: 'create room',
        group: 'action',
        parents: ['Rooms'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'room', type: 'TextInput', col: '12', information: { label: '{{lang}}Room', placeholder: '{{lang}}Room', required: true } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'fileShared': {
        key: 'fileShared',
        title: 'file shared',
        group: 'trigger',
        parents: ['Rooms'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'shareFile': {
        key: 'shareFile',
        title: 'share file',
        group: 'action',
        parents: ['Rooms'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'file', type: 'FileInput', col: '12', information: { label: '{{lang}}File', placeholder: '{{lang}}File', required: true } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    //ticketing
    //flowcontrol
    // 'getTicketStatus': {
    //     key: 'getTicketStatus',
    //     title: 'get ticket status',
    //     group: 'operator',
    //     parents: ['controlUnits'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    //trigger-action
    'ticketReceived': {
        key: 'ticketReceived',
        title: 'ticket received',
        group: 'trigger',
        parents: ['ticketing'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'receiveTicket': {
        key: 'receiveTicket',
        title: 'receive ticket',
        group: 'action',
        parents: ['ticketing'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'ticketSent': {
        key: 'ticketSent',
        title: 'ticket sent',
        group: 'trigger',
        parents: ['ticketing'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'sendTicket': {
        key: 'sendTicket',
        title: 'send ticket',
        group: 'action',
        parents: ['ticketing'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'message', type: 'TextInput', col: '12', information: { label: '{{lang}}Message', placeholder: '{{lang}}Message', required: true } },
            { key: 'description', type: 'TextInput', col: '12', information: { label: '{{lang}}Description', placeholder: '{{lang}}Description', required: true } },
            { key: 'user', type: 'TextInput', col: '12', information: { label: '{{lang}}User', placeholder: '{{lang}}User', required: true } },
            { key: 'assignee', type: 'TextInput', col: '12', information: { label: '{{lang}}Assignee', placeholder: '{{lang}}Assignee', required: true } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'ticketAssinged': {
        key: 'ticketAssing',
        title: 'ticket Assing',
        group: 'trigger',
        parents: ['ticketing'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'assingTicket': {
        key: 'assingTicket',
        title: 'assing ticket',
        group: 'action',
        parents: ['ticketing'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'assign', type: 'TextInput', col: '12', information: { label: '{{lang}}Assign', placeholder: '{{lang}}Assign', required: true } },
            { key: 'ticketId', type: 'TextInput', col: '12', information: { label: '{{lang}}Ticket Id', placeholder: '{{lang}}Ticket Id', required: true } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'ticketAssingeeChanged': {
        key: 'ticketAssingeeChanged',
        title: 'ticket assingee changed',
        group: 'trigger',
        parents: ['ticketing'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'changeAssingeeTicket': {
        key: 'changeAssingeeTicket',
        title: 'change assingee ticket',
        group: 'action',
        parents: ['ticketing'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'assign', type: 'TextInput', col: '12', information: { label: '{{lang}}Assign', placeholder: '{{lang}}Assign', required: true } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'ticketStatusChanged': {
        key: 'ticketStatusChanged',
        title: 'ticket status changed',
        group: 'trigger',
        parents: ['ticketing'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'changeTicketStatus': {
        key: 'changeTicketStatus',
        title: 'change ticket status',
        group: 'action',
        parents: ['ticketing'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'state', type: 'TextInput', col: '12', information: { label: '{{lang}}State', placeholder: '{{lang}}State', required: true } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    //social
    //flowcontrol
    // 'getPosts': {
    //     key: 'getPosts',
    //     title: 'get posts',
    //     group: 'operator',
    //     parents: ['controlUnits'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'getMembers': {
    //     key: 'getMembers',
    //     title: 'get members',
    //     group: 'operator',
    //     parents: ['controlUnits'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'getPostSeen': {
    //     key: 'getPostSeen',
    //     title: 'get post seen',
    //     group: 'operator',
    //     parents: ['controlUnits'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    //trigger-action
    // 'postSent': {
    //     key: 'postSent',
    //     title: 'post sent',
    //     group: 'trigger',
    //     parents: ['social'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'sendPost': {
    //     key: 'sendPost',
    //     title: 'send post',
    //     group: 'action',
    //     parents: ['social'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'description', type: 'TextInput', col: '12', information: { label: '{{lang}}Description',  placeholder: '{{lang}}Description', required: true } },
    //         { key: 'file', type: 'FileInput', col: '12', information: { label: '{{lang}}File',  placeholder: '{{lang}}File', required: true } },
    //         { key: 'image', type: 'FileInput', col: '12', information: { label: '{{lang}}Image',  placeholder: '{{lang}}Image', required: true } },
    //         { key: 'video', type: 'FileInput', col: '12', information: { label: '{{lang}}Video',  placeholder: '{{lang}}Video', required: true } },
    //         { key: 'caption', type: 'TextInput', col: '12', information: { label: '{{lang}}Caption',  placeholder: '{{lang}}Caption', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    // 'postReceived': {
    //     key: 'postReceived',
    //     title: 'post received',
    //     group: 'trigger',
    //     parents: ['social'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'receivePost': {
    //     key: 'receivePost',
    //     title: 'receive post',
    //     group: 'action',
    //     parents: ['social'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [

    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    // 'postDeleted': {
    //     key: 'postDeleted',
    //     title: 'post deleted',
    //     group: 'trigger',
    //     parents: ['social'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'deletePost': {
    //     key: 'deletePost',
    //     title: 'delete post',
    //     group: 'action',
    //     parents: ['social'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [

    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    // 'postShared': {
    //     key: 'postShared',
    //     title: 'post shared',
    //     group: 'trigger',
    //     parents: ['social'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'sharePost': {
    //     key: 'sharePost',
    //     title: 'share post',
    //     group: 'action',
    //     parents: ['social'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [

    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    // 'postLiked': {
    //     key: 'postLiked',
    //     title: 'post liked',
    //     group: 'trigger',
    //     parents: ['social'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'likePost': {
    //     key: 'likePost',
    //     title: 'like post',
    //     group: 'action',
    //     parents: ['social'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [

    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    // 'postUnliked': {
    //     key: 'postUnliked',
    //     title: 'post unliked',
    //     group: 'trigger',
    //     parents: ['social'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'unlikePost': {
    //     key: 'unlikePost',
    //     title: 'unlike post',
    //     group: 'action',
    //     parents: ['social'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [

    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    // 'commentedOnPost': {
    //     key: 'commentedOnPost',
    //     title: 'commented on post',
    //     group: 'trigger',
    //     parents: ['social'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'commentOnPost': {
    //     key: 'commentOnPost',
    //     title: 'comment on post',
    //     group: 'action',
    //     parents: ['social'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'text', type: 'TextInput', col: '12', information: { label: '{{lang}}Text',  placeholder: '{{lang}}Text', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    // 'CommentedOnPostRemoved': {
    //     key: 'commentedOnPostRemoved',
    //     title: 'commented on post removed',
    //     group: 'trigger',
    //     parents: ['social'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'removeCommentOnPost': {
    //     key: 'removeCommentOnPost',
    //     title: 'remove comment on post',
    //     group: 'action',
    //     parents: ['social'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    // 'CommentedOnPostChange': {
    //     key: 'commentedOnPostChange',
    //     title: 'commented on post change',
    //     group: 'trigger',
    //     parents: ['social'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'changeCommentOnPost': {
    //     key: 'changeCommentOnPost',
    //     title: 'change comment on post',
    //     group: 'action',
    //     parents: ['social'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'text', type: 'TextInput', col: '12', information: { label: '{{lang}}Text',  placeholder: '{{lang}}Text', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    // 'postSaved': {
    //     key: 'postSaved',
    //     title: 'post saved',
    //     group: 'trigger',
    //     parents: ['social'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'savePost': {
    //     key: 'savePost',
    //     title: 'save post',
    //     group: 'action',
    //     parents: ['social'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    // 'userTagged': {
    //     key: 'userTagged',
    //     title: 'user tagged',
    //     group: 'trigger',
    //     parents: ['social'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'tagUser': {
    //     key: 'tagUser',
    //     title: 'tag user',
    //     group: 'action',
    //     parents: ['social'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'text', type: 'TextInput', col: '12', information: { label: '{{lang}}Text',  placeholder: '{{lang}}Text', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    // 'socialFollowed': {
    //     key: 'socialFollowed',
    //     title: 'social followed',
    //     group: 'trigger',
    //     parents: ['social'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'followSocial': {
    //     key: 'followSocial',
    //     title: 'follow social',
    //     group: 'action',
    //     parents: ['social'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    // 'socialUnfollowed': {
    //     key: 'socialUnfollowed',
    //     title: 'social unfollowed',
    //     group: 'trigger',
    //     parents: ['social'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'unfollowSocial': {
    //     key: 'unfollowSocial',
    //     title: 'unfollow social',
    //     group: 'action',
    //     parents: ['social'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    // 'categorizeSocial': {
    //     key: 'categorizeSocial',
    //     title: 'categorize social',
    //     group: 'action',
    //     parents: ['social'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}Name',  placeholder: '{{lang}}Name', required: true } },
    //         { key: 'post', type: 'TextInput', col: '12', information: { label: '{{lang}}Post',  placeholder: '{{lang}}Post', required: true } },

    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    //wallet-score
    //flowcontrol
    // 'getUserWallet': {
    //     key: 'getUserWallet',
    //     title: 'get user wallet',
    //     group: 'operator',
    //     parents: ['controlUnits'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'getUserScore': {
    //     key: 'getUserScore',
    //     title: 'get user score',
    //     group: 'operator',
    //     parents: ['controlUnits'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },

    //trigger-action
    // 'scoreIncreased': {
    //     key: 'scoreIncreased',
    //     title: 'score increased',
    //     group: 'trigger',
    //     parents: ['wallet'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'increaseScore': {
    //     key: 'increaseScore',
    //     title: 'increase score',
    //     group: 'action',
    //     parents: ['wallet'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'count', type: 'TextInput', col: '12', information: { label: '{{lang}}Count',  placeholder: '{{lang}}Count', required: true } },

    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    // 'scoreDecreased': {
    //     key: 'scoreDecreased',
    //     title: 'score decreased',
    //     group: 'trigger',
    //     parents: ['wallet'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'decreaseScore': {
    //     key: 'decreaseScore',
    //     title: 'decrease score',
    //     group: 'action',
    //     parents: ['wallet'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'count', type: 'TextInput', col: '12', information: { label: '{{lang}}Count',  placeholder: '{{lang}}Count', required: true } },

    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    // 'settedScoreDiscount': {
    //     key: 'settedScoreDiscount',
    //     title: 'setted score discount',
    //     group: 'trigger',
    //     parents: ['wallet'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'setScoreDiscount': {
    //     key: 'setScoreDiscount',
    //     title: 'set score discount',
    //     group: 'action',
    //     parents: ['wallet'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'count', type: 'TextInput', col: '12', information: { label: '{{lang}}Count',  placeholder: '{{lang}}Count', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    // 'settedWalletCommision': {
    //     key: 'settedWalletCommision',
    //     title: 'setted wallet commision',
    //     group: 'trigger',
    //     parents: ['wallet'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'setWalletCommision': {
    //     key: 'setWalletCommision',
    //     title: 'setWalletCommision',
    //     group: 'action',
    //     parents: ['wallet'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'amount', type: 'TextInput', col: '12', information: { label: '{{lang}}Amount',  placeholder: '{{lang}}Amount', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    //Question
    //flowcontrol
    // 'getQuestions': {
    //     key: 'getQuestions',
    //     title: 'get questions',
    //     group: 'operator',
    //     parents: ['controlUnits'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    //trigger-action
    'onInquiryCreated': {
        key: 'onInquiryCreated',
        title: 'On Inquiry Created',
        group: 'trigger',
        parents: ['Inquiry'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/onInquiryCreated.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'onParticipateQuiz': {
        key: 'onParticipateQuiz',
        title: 'On Participate Quiz',
        group: 'trigger',
        parents: ['Inquiry'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/onInquiryCreated.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
            {
                key: 'frame', type: 'SelectInput', col: '12', information: { label: '{{lang}}frame', type: 'api', address: 'getFrames', filter: { applet: '{{appletId}}' }, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}Select ...', required: false }, showMain: false,
                dependencies: [{
                    refKey: 'applet',
                    targetKey: 'frame',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: '@data.applet' }, operator: { value: '!=' }, target: { value: null } },
                                // 1: { id: 1, source: { value: '@data.applet' }, operator: { value: '==' }, target: { value: 'frame' } },
                            }
                        },
                    },
                    show: true,
                    init: true,
                    changeHeader: { key: 'information.filter.applet', value: '@data.applet' },
                }],
            },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'createInquiry': {
        key: 'createInquiry',
        title: 'create Inquiry',
        group: 'action',
        parents: ['Inquiry'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/createInquiry.svg',
        headers: [
            { key: 'Inquiry', type: 'TextInput', col: '12', information: { label: '{{lang}}Question', placeholder: '{{lang}}Question', required: true } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'onInquiryChanged': {
        key: 'onInquiryChanged',
        title: 'On Inquiry Changed',
        group: 'trigger',
        parents: ['Inquiry'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/onInquiryChanged.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'changeInquiry': {
        key: 'changeInquiry',
        title: 'Change Inquiry',
        group: 'action',
        parents: ['Inquiry'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/changeInquiry.svg',
        headers: [
            { key: 'question', type: 'TextInput', col: '12', information: { label: '{{lang}}Question', placeholder: '{{lang}}Question', required: true } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'onInquiryRemoved': {
        key: 'onInquiryRemoved',
        title: 'On Inquiry Removed',
        group: 'trigger',
        parents: ['Inquiry'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/onInquiryRemoved.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'removeInquiry': {
        key: 'removeInquiry',
        title: 'Remove Inquiry',
        group: 'action',
        parents: ['Inquiry'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/removeInquiry.svg',
        headers: [
            { key: 'question', type: 'TextInput', col: '12', information: { label: '{{lang}}Question', placeholder: '{{lang}}Question', required: true } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'onInquirySubmited': {
        key: 'onInquirySubmited',
        title: 'On Inquiry submited',
        group: 'trigger',
        parents: ['Inquiry'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/onInquirySubmited.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'submitInquiry': {
        key: 'submitInquiry',
        title: 'Submit Inquiry',
        group: 'action',
        parents: ['Inquiry'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/submitInquiry.svg',
        headers: [
            { key: 'question', type: 'TextInput', col: '12', information: { label: '{{lang}}Question', placeholder: '{{lang}}Question', required: true } },
            { key: 'answer', type: 'TextInput', col: '12', information: { label: '{{lang}}Answer', placeholder: '{{lang}}Answer', required: true } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'onAnswerCreated': {
        key: 'onAnswerCreated',
        title: 'On Answer Created',
        group: 'trigger',
        parents: ['Inquiry'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/onAnswerCreated.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'createAnswer': {
        key: 'createAnswer',
        title: 'Create Answer',
        group: 'action',
        parents: ['Inquiry'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/createAnswer.svg',
        headers: [
            { key: 'answer', type: 'TextInput', col: '12', information: { label: '{{lang}}Answer', placeholder: '{{lang}}Answer', required: true } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'onAnswerChanged': {
        key: 'onAnswerChanged',
        title: 'On Answer Changed',
        group: 'trigger',
        parents: ['Inquiry'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/onAnswerChanged.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'changeAnswer': {
        key: 'changeAnswer',
        title: 'Change Answer',
        group: 'action',
        parents: ['Inquiry'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/changeAnswer.svg',
        headers: [
            { key: 'answer', type: 'TextInput', col: '12', information: { label: '{{lang}}Answer', placeholder: '{{lang}}Answer', required: true } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'onAnswerRemoved': {
        key: 'onAnswerRemoved',
        title: 'On Answer Removed',
        group: 'trigger',
        parents: ['Inquiry'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/onAnswerRemoved.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'removeAnswer': {
        key: 'removeAnswer',
        title: 'Remove Answer',
        group: 'action',
        parents: ['Inquiry'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/removeAnswer.svg',
        headers: [
            { key: 'answer', type: 'TextInput', col: '12', information: { label: '{{lang}}Answer', placeholder: '{{lang}}Answer', required: true } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },

    //email
    //flowcontrol
    // 'getMails': {
    //     key: 'getMails',
    //     title: 'get mails',
    //     group: 'operator',
    //     parents: ['controlUnits'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    //trigger-action
    // 'emailReceived': {
    //     key: 'emailReceived',
    //     title: 'email received',
    //     group: 'trigger',
    //     parents: ['email'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'receiveEmail': {
    //     key: 'receiveEmail',
    //     title: 'receive email',
    //     group: 'action',
    //     parents: ['email'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    // 'emailSent': {
    //     key: 'emailSent',
    //     title: 'email sent',
    //     group: 'trigger',
    //     parents: ['email'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    'sendEmail': {
        key: 'sendEmail',
        title: 'send email',
        group: 'action',
        parents: ['controlUnits'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'recipients', type: 'TextInput', col: '12', information: { label: '{{lang}}Recipients', placeholder: '{{lang}}Recipients', required: true } },
            { key: 'subject', type: 'TextInput', col: '12', information: { label: '{{lang}}Subject', placeholder: '{{lang}}Subject', required: true } },
            { key: 'message', type: 'TextInput', col: '12', information: { label: '{{lang}}Message', placeholder: '{{lang}}Message', required: true } },

        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },


    'sendSMS': {
        key: 'sendSMS',
        title: 'send SMS',
        group: 'action',
        parents: ['controlUnits'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/number.png',
        headers: [
            { key: 'recipients', type: 'TextInput', col: '12', information: { label: '{{lang}}Recipients', placeholder: '{{lang}}Recipients', required: true } },
            { key: 'subject', type: 'TextInput', col: '12', information: { label: '{{lang}}Subject', placeholder: '{{lang}}Subject', required: true } },
            { key: 'message', type: 'TextInput', col: '12', information: { label: '{{lang}}Message', placeholder: '{{lang}}Message', required: true } },

        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    // 'emailMarked': {
    //     key: 'emailMarked',
    //     title: 'email marked',
    //     group: 'trigger',
    //     parents: ['email'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'markEmail': {
    //     key: 'markEmail',
    //     title: 'mark email',
    //     group: 'action',
    //     parents: ['email'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    // 'emailMarked': {
    //     key: 'emailMarked',
    //     title: 'email marked',
    //     group: 'trigger',
    //     parents: ['email'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'markEmail': {
    //     key: 'markEmail',
    //     title: 'mark email',
    //     group: 'action',
    //     parents: ['email'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    // 'emailReplied': {
    //     key: 'emailReplied',
    //     title: 'email replied',
    //     group: 'trigger',
    //     parents: ['email'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'replyEmail': {
    //     key: 'replyEmail',
    //     title: 'reply email',
    //     group: 'action',
    //     parents: ['email'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    // 'emailForward': {
    //     key: 'emailForward',
    //     title: 'email forward',
    //     group: 'trigger',
    //     parents: ['email'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'forwardEmail': {
    //     key: 'forwardEmail',
    //     title: 'forward email',
    //     group: 'action',
    //     parents: ['email'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    // 'emailReported': {
    //     key: 'emailReported',
    //     title: 'email reported',
    //     group: 'trigger',
    //     parents: ['email'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'reportEmail': {
    //     key: 'reportEmail',
    //     title: 'report email',
    //     group: 'action',
    //     parents: ['email'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    //notebook
    //flowcontrol
    // 'getNotes': {
    //     key: 'getNotes',
    //     title: 'get notes',
    //     group: 'operator',
    //     parents: ['controlUnits'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    //trigger-action
    'notebookAdded': {
        key: 'notebookAdded',
        title: 'notebook added',
        group: 'trigger',
        parents: ['NoteBook'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/notebookAdded.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'addNotebook': {
        key: 'addNotebook',
        title: 'add notebook',
        group: 'action',
        parents: ['NoteBook'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/addNotebook.svg',
        headers: [
            { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}Title', placeholder: '{{lang}}Title', required: true } },
            { key: 'body', type: 'TextInput', col: '12', information: { label: '{{lang}}Body', placeholder: '{{lang}}Body', required: true } },

        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'notebookChanged': {
        key: 'notebookChanged',
        title: 'notebook changed',
        group: 'trigger',
        parents: ['NoteBook'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/notebookChanged.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'changeNotebook': {
        key: 'changeNotebook',
        title: 'change notebook',
        group: 'action',
        parents: ['NoteBook'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/changeNotebook.svg',
        headers: [
            { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}Title', placeholder: '{{lang}}Title', required: true } },
            { key: 'body', type: 'TextInput', col: '12', information: { label: '{{lang}}Body', placeholder: '{{lang}}Body', required: true } },

        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    'notebookRemoved': {
        key: 'notebookRemoved',
        title: 'notebook removed',
        group: 'trigger',
        parents: ['NoteBook'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/notebookRemoved.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: true } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'removeNotebook': {
        key: 'removeNotebook',
        title: 'remove notebook',
        group: 'action',
        parents: ['NoteBook'],
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/removeNotebook.svg',
        headers: [

        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },
    //tracking
    //flowcontrol
    // 'getTracking': {
    //     key: 'getTracking',
    //     title: 'get tracking',
    //     group: 'operator',
    //     parents: ['controlUnits'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    //trigger-action
    // 'trackingStarted': {
    //     key: 'trackingStarted',
    //     title: 'tracking started',
    //     group: 'trigger',
    //     parents: ['tracking'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'startTracking': {
    //     key: 'startTracking',
    //     title: 'start tracking',
    //     group: 'action',
    //     parents: ['tracking'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [

    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    // 'trackingEnded': {
    //     key: 'trackingEnded',
    //     title: 'tracking ended',
    //     group: 'trigger',
    //     parents: ['tracking'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'endTracking': {
    //     key: 'endTracking',
    //     title: 'end tracking',
    //     group: 'action',
    //     parents: ['tracking'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [

    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    // 'trackingStatusChanged': {
    //     key: 'trackingStatusChanged',
    //     title: 'tracking status changed',
    //     group: 'trigger',
    //     parents: ['tracking'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'changeTrackingStatus': {
    //     key: 'changeTrackingStatus',
    //     title: 'change tracking status',
    //     group: 'action',
    //     parents: ['tracking'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [

    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    //inventory
    //flowcontrol
    // 'getInventory': {
    //     key: 'getInventory',
    //     title: 'get inventory',
    //     group: 'operator',
    //     parents: ['controlUnits'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    //trigger-action
    // 'inventoryCreated': {
    //     key: 'inventoryCreated',
    //     title: 'inventory created',
    //     group: 'trigger',
    //     parents: ['tracking'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'createInventory': {
    //     key: 'createInventory',
    //     title: 'create inventory',
    //     group: 'action',
    //     parents: ['tracking'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}Name',  placeholder: '{{lang}}Name', required: true } },

    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    // 'inventoryProductAdded': {
    //     key: 'inventoryProductAdded',
    //     title: 'inventory product added',
    //     group: 'trigger',
    //     parents: ['tracking'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'inventoryAddProduct': {
    //     key: 'inventoryAddProduct',
    //     title: 'inventory add product',
    //     group: 'action',
    //     parents: ['tracking'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}Name',  placeholder: '{{lang}}Name', required: true } },
    //         { key: 'amount', type: 'TextInput', col: '12', information: { label: '{{lang}}Amount',  placeholder: '{{lang}}Amount', required: true } },

    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    // 'certificateIssuenced': {
    //     key: 'certificateIssuenced',
    //     title: 'certificate issuenced',
    //     group: 'trigger',
    //     parents: ['tracking'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'certificateIssuence': {
    //     key: 'certificateIssuence',
    //     title: 'certificate issuence',
    //     group: 'action',
    //     parents: ['tracking'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}Name',  placeholder: '{{lang}}Name', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },
    // 'inventoryAdjustmented': {
    //     key: 'inventoryAdjustmented',
    //     title: 'inventory adjustmented',
    //     group: 'trigger',
    //     parents: ['tracking'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'applet', type: 'TextInput', col: '12', information: { label: '{{lang}}Applet',  placeholder: '{{lang}}Applet', required: true } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'inventoryAdjustment': {
    //     key: 'inventoryAdjustment',
    //     title: 'inventory adjustment',
    //     group: 'action',
    //     parents: ['tracking'],
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [
    //         { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}Name',  placeholder: '{{lang}}Name', required: true } },
    //         { key: 'count', type: 'TextInput', col: '12', information: { label: '{{lang}}Count',  placeholder: '{{lang}}Count', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //     }
    // },


    // 'onRequest': {
    //     key: 'onRequest',
    //     title: '{{lang}}on request',
    //     group: 'trigger',
    //     // UI: { type: 'circle', borderRadius: '50%', width: 120, bodyColor: '#D098A5', bodyColorS: '#93A8D0', bodyColorE: '#A3ABBD', showIcon: 'https://www.flaticon.com/svg/static/icons/svg/3036/3036996.svg' },
    //     UI: { type: 'circle', borderRadius: '50%', width: 80, bodyColorS: '#4B5CF1', bodyColorE: '#7B51F1', showIcon: '/assets/icons/elements/number.png' },

    //     parents: ['Database', 'sequence', 'Messenger', 'Commerce', 'Finance', 'Booking', 'Tasking'],
    //     icon: '/assets/icons/elements/number.png',
    //     headers: [

    //         { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}label',  placeholder: '{{lang}}insertLabel', required: true } },
    //         { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    'submitForm': {
        key: 'submitForm',
        title: '{{lang}}Submit Form',
        group: 'action',
        // UI: { type: 'circle', borderRadius: '50%', width: 120, bodyColor: '#D098A5', bodyColorS: '#93A8D0', bodyColorE: '#A3ABBD', showIcon: 'https://www.flaticon.com/svg/static/icons/svg/3036/3036996.svg' },
        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        // UI: { type: 'circle', borderRadius: '50%', width: 80, bodyColorS: '#4B5CF1', bodyColorE: '#7B51F1', showIcon: '/assets/icons/elements/number.png' },

        parents: ['Database'],
        icon: '/assets/icons/elements/submitForm.svg',
        headers: [
            { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}label', placeholder: '{{lang}}insertLabel', required: true } },
            { key: 'applet', type: 'SelectInput', col: '12', information: { label: '{{lang}}applet', type: 'api', address: 'getMyAppletList', filter: {}, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}insertLabel', required: true }, disabled: true },
            {
                key: 'frame', type: 'SelectInput', col: '12', information: { label: '{{lang}}frame', type: 'api', address: 'getFrames', filter: { applet: '{{appletId}}' }, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}Select ...', required: false }, showMain: false,
                dependencies: [{
                    refKey: 'applet',
                    targetKey: 'frame',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: '@data.applet' }, operator: { value: '!=' }, target: { value: null } },
                                // 1: { id: 1, source: { value: '@data.applet' }, operator: { value: '==' }, target: { value: 'frame' } },
                            }
                        },
                    },
                    show: true,
                    init: true,
                    changeHeader: { key: 'information.filter.applet', value: '@data.applet' },
                }],
            },
            {
                key: 'fields', type: 'FieldsInput', col: '12', information: { label: '{{lang}}fields', type: 'api', filter: { _id: '{{frame}}' }, address: 'getFrameFields', fields: { title: 'type', value: '' }, placeholder: '{{lang}}insertFields' },
                dependencies: [{
                    refKey: 'frame',
                    targetKey: 'fields',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'and',
                            conditions: {
                                1: { id: 1, source: { value: '@data.frame' }, operator: { value: '!=' }, target: { value: '' } },
                                2: { id: 2, source: { value: '@data.frame' }, operator: { value: '!=' }, target: { value: null } },
                                // 1: { id: 1, source: { value: '@data.applet' }, operator: { value: '==' }, target: { value: 'frame' } },
                            }
                        },
                    },
                    show: true,
                    init: true,
                    changeHeader: { key: 'information.filter._id', value: '@data.frame' },
                }],
            },
            { key: 'creator', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}creator', type: 'api', address: 'searchUser', filter: { applet: '{{appletId}}' }, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, placeholder: '{{lang}}creator' } },
            // { key: 'value', type: 'TextInput', col: '12', information: { label: '{{lang}}value',  placeholder: '{{lang}}insertValue', required: true } },
            // { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },

    'onFormSubmit': {
        key: 'onFormSubmit',
        title: '{{lang}}On Form Submit',
        group: 'trigger',
        // UI: { type: 'circle', borderRadius: '50%', width: 120, bodyColor: '#D098A5', bodyColorS: '#93A8D0', bodyColorE: '#A3ABBD', showIcon: 'https://www.flaticon.com/svg/static/icons/svg/3036/3036996.svg' },
        UI: { type: "trigger", bodyColorE: "#fff", bodyColorS: "#fff", borderRadius: "50%", showIcon: '/assets/icons/forms/number.png', width: 80 },
        // UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        // UI: { type: 'circle', borderRadius: '50%', width: 80, bodyColorS: '#4B5CF1', bodyColorE: '#7B51F1', showIcon: '/assets/icons/elements/number.png' },

        parents: ['controlUnits'],
        icon: '/assets/icons/elements/add-post (1).png',
        headers: [
            { key: 'applet', type: 'SelectInput', col: '12', information: { label: '{{lang}}applet', type: 'api', address: 'getMyAppletList', filter: {}, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}insertLabel', required: true }, disabled: true },
            {
                key: 'frame', type: 'SelectInput', col: '12', information: { label: '{{lang}}frame', type: 'api', address: 'getFrames', filter: { applet: '{{appletId}}' }, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}frame', required: false }, showMain: false,
                dependencies: [{
                    refKey: 'applet',
                    targetKey: 'frame',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: '@data.applet' }, operator: { value: '!=' }, target: { value: null } },
                                // 1: { id: 1, source: { value: '@data.applet' }, operator: { value: '==' }, target: { value: 'frame' } },
                            }
                        },
                    },
                    show: true,
                    init: true,
                    changeHeader: { key: 'information.filter.applet', value: '@data.applet' },
                }],
            },
            { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}label', placeholder: '{{lang}}insertLabel', required: true } },
            { key: 'fields', type: 'SelectInput', col: '12', information: { label: '{{lang}}fields', placeholder: '{{lang}}insertFields' } },
            { key: 'value', type: 'TextInput', col: '12', information: { label: '{{lang}}value', placeholder: '{{lang}}insertValue', required: true } },
            // { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
        ],
        defaultNodes: {
            // 'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },


    // 'recordTrigger': {
    //     key: 'recordTrigger',
    //     title: '{{lang}}Record Trigger',
    //     group: 'trigger',
    //     // UI: { type: 'circle', borderRadius: '50%', width: 120, bodyColor: '#D098A5', bodyColorS: '#93A8D0', bodyColorE: '#A3ABBD', showIcon: 'https://www.flaticon.com/svg/static/icons/svg/3036/3036996.svg' },
    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     // UI: { type: 'circle', borderRadius: '50%', width: 80, bodyColorS: '#4B5CF1', bodyColorE: '#7B51F1', showIcon: '/assets/icons/elements/number.png' },

    //     parents: ['controlUnits'],
    //     icon: '/assets/icons/elements/onFormSubmit.svg',
    //     headers: [
    //         // { key: 'applet', type: 'SelectInput', col: '12', information: { label: '{{lang}}applet', type: 'api', address: 'getMyAppletList', filter: {}, fields: { title: 'name', value: '_id' },  placeholder: '{{lang}}insertLabel', required: true }, disabled: true },
    //         // {
    //         //     key: 'frame', type: 'SelectInput', col: '12', information: { label: '{{lang}}frame', type: 'api', address: 'getFrames', filter: { applet: '{{appletId}}' }, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}frame', required: false }, showMain: false,
    //         //     dependencies: [{
    //         //         refKey: 'applet',
    //         //         targetKey: 'frame',
    //         //         conditions: {
    //         //             root: {
    //         //                 id: 'root',
    //         //                 action: 'or',
    //         //                 conditions: {
    //         //                     1: { id: 1, source: { value: '@data.applet' }, operator: { value: '!=' }, target: { value: null } },
    //         //                     // 1: { id: 1, source: { value: '@data.applet' }, operator: { value: '==' }, target: { value: 'frame' } },
    //         //                 }
    //         //             },
    //         //         },
    //         //         show: true,
    //         //         init: true,
    //         //         changeHeader: { key: 'information.filter.applet', value: '@data.applet' },
    //         //     }],
    //         // },
    //         { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}label', placeholder: '{{lang}}insertLabel', required: true } },
    //         { key: 'variableName', type: 'TextInput', col: '12', information: { label: '{{lang}}Variable Name', required: true } },
    //         // { key: 'record', type: 'SelectInput', col: '12', information: { label: '{{lang}}records',  fields: { title: '_id', value: '_id' }, filter: { applet: '{{appletId}}' }, required: true } },

    //         // { key: 'fields', type: 'SelectInput', col: '12', information: { label: '{{lang}}fields',  placeholder: '{{lang}}insertFields' } },
    //         // { key: 'value', type: 'TextInput', col: '12', information: { label: '{{lang}}value',  placeholder: '{{lang}}insertValue', required: true } },
    //         // { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
    //     ],
    //     defaultNodes: {
    //         // 'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },

    'onUpdatedField': {
        key: 'onUpdatedField',
        title: '{{lang}}On Updated Field',
        group: 'trigger',

        parents: ['controlUnits'],

        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/onUpdatedField.svg',
        headers: [
            { key: 'applet', type: 'TextInput', col: '2', information: { label: '{{lang}}Applet', icon: '/assets/icons/elements/number.png', placeholder: '{{lang}}Applet', required: false } },
        ],
        defaultNodes: {
            // 'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    //flowControl
    'idGenerator': {
        key: 'idGenerator',
        title: '{{lang}}Generate Id',
        group: 'operator',

        parents: ['controlUnits'],

        UI: { type: 'operator', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/idGenerator.svg',
        headers: [
            { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}label', placeholder: '{{lang}}insertLabel', required: true } },
            { key: 'applet', type: 'SelectInput', col: '2', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: false } },
            { key: 'id', type: 'TextInput', col: '2', information: { label: '{{lang}}ID', placeholder: '{{lang}}ID', required: false } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'calculator': {
        key: 'calculator',
        title: '{{lang}}calculator',
        group: 'operator',

        parents: ['controlUnits'],

        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/calculator.svg',
        headers: [
            { key: 'applet', type: 'SelectInput', col: '2', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: false } },
            { key: 'id', type: 'TextInput', col: '2', information: { label: '{{lang}}ID', placeholder: '{{lang}}ID', required: false } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'randomNumber': {
        key: 'randomNumber',
        title: '{{lang}}random number',
        group: 'operator',

        parents: ['controlUnits'],

        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/randomNumber.svg',
        headers: [
            { key: 'applet', type: 'SelectInput', col: '2', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: false } },
            { key: 'id', type: 'TextInput', col: '2', information: { label: '{{lang}}ID', placeholder: '{{lang}}ID', required: false } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'onUpdateSettings': {
        key: 'onUpdateSettings',
        title: 'On Update Settings',
        group: 'operator',

        parents: ['Settings'],

        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/email.svg',
        headers: [
            { key: 'applet', type: 'SelectInput', col: '2', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: false } },
            { key: 'id', type: 'TextInput', col: '2', information: { label: '{{lang}}ID', placeholder: '{{lang}}ID', required: false } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'updateSettings': {
        key: 'updateSettings',
        title: 'Update Settings',
        group: 'operator',

        parents: ['Settings'],

        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/email.png',
        headers: [
            { key: 'applet', type: 'SelectInput', col: '2', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: false } },
            { key: 'id', type: 'TextInput', col: '2', information: { label: '{{lang}}ID', placeholder: '{{lang}}ID', required: false } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'onUpdatePermissions': {
        key: 'onUpdatePermissions',
        title: 'On Update Permissions',
        group: 'operator',

        parents: ['controlUnits'],

        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/onUpdatePermissions.svg',
        headers: [
            { key: 'applet', type: 'SelectInput', col: '2', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: false } },
            { key: 'id', type: 'TextInput', col: '2', information: { label: '{{lang}}ID', placeholder: '{{lang}}ID', required: false } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'updatePermissions': {
        key: 'updatePermissions',
        title: 'Update Permissions',
        group: 'operator',

        parents: ['controlUnits'],

        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/updatePermissions.svg',
        headers: [
            { key: 'applet', type: 'SelectInput', col: '2', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: false } },
            { key: 'id', type: 'TextInput', col: '2', information: { label: '{{lang}}ID', placeholder: '{{lang}}ID', required: false } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'onAddCollection': {
        key: 'onAddCollection',
        title: 'On Add Collection',
        group: 'operator',

        parents: ['controlUnits'],

        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/onAddCollection.svg',
        headers: [
            { key: 'applet', type: 'SelectInput', col: '2', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: false } },
            { key: 'id', type: 'TextInput', col: '2', information: { label: '{{lang}}ID', placeholder: '{{lang}}ID', required: false } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    'addCollection': {
        key: 'addCollection',
        title: 'Add Collection',
        group: 'operator',

        parents: ['controlUnits'],

        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/addCollection.svg',
        headers: [
            { key: 'applet', type: 'SelectInput', col: '2', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: false } },
            { key: 'id', type: 'TextInput', col: '2', information: { label: '{{lang}}ID', placeholder: '{{lang}}ID', required: false } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },

    // 'syncData': {
    //     key: 'syncData',
    //     title: '{{lang}}sync data',
    //     group: 'operator',

    //     parents: ['controlUnits'],

    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/email.png',
    //     headers: [
    //         { key: 'applet', type: 'SelectInput', col: '2', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: false } },
    //         { key: 'id', type: 'TextInput', col: '2', information: { label: '{{lang}}ID', placeholder: '{{lang}}ID', required: false } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },
    // 'webhook': {
    //     key: 'webhook',
    //     title: '{{lang}}webhook',
    //     group: 'operator',

    //     parents: ['controlUnits'],

    //     UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
    //     icon: '/assets/icons/elements/email.png',
    //     headers: [
    //         { key: 'applet', type: 'SelectInput', col: '2', information: { label: '{{lang}}Applet', placeholder: '{{lang}}Applet', required: false } },
    //         { key: 'id', type: 'TextInput', col: '2', information: { label: '{{lang}}ID', placeholder: '{{lang}}ID', required: false } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },

    //filters

    'updateField': {
        key: 'updateField',
        title: '{{lang}}Update Field',
        group: 'action',

        parents: ['controlUnits'],

        UI: { type: 'stage', borderRadius: '8px', width: 150, bodyColorS: '#fff', bodyColorE: '#fff', showIcon: '/assets/icons/elements/number.png' },
        icon: '/assets/icons/elements/updateField.svg',
        headers: [
            { key: 'applet', type: 'SelectInput', col: '2', information: { label: '{{lang}}Applet', type: '', items: [], placeholder: '{{lang}}Applet', required: false } },
            { key: 'field', type: 'SelectInput', col: '2', information: { label: '{{lang}}Field', type: '', items: [], placeholder: '{{lang}}Field', required: false } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            // 'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },
    // 'removeData': {
    //     key: 'removeData',
    //     title: '{{lang}}Remove Data',
    //     group: 'action',

    //     parents: ['Database'],

    //     UI: { type: 'stage', borderRadius: '8px', height: 44, bodyColor: '#ee5050', textColor: '#fff', border: '2px solid #E5417C', bodyColorS: '#ee5050', bodyColorE: '#E5417C' },
    //     icon: '/assets/icons/elements/email.png',
    //     headers: [
    //         { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}label',  placeholder: '{{lang}}insertLabel', required: true } },
    //         { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         // 'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },



    'fieldUpdated': {
        key: 'fieldUpdated',
        title: '{{lang}}Field Updated',
        group: 'trigger',

        parents: ['Database'],

        UI: { type: 'stage', borderRadius: '8px', height: 44, bodyColor: '#333', textColor: '#333', border: '2px solid #d0d0d0', bodyColorS: '#ddd', bodyColorE: '#ddd' },
        icon: '/assets/icons/elements/fieldUpdated.svg',
        headers: [
            { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}label', placeholder: '{{lang}}insertLabel', required: true } },
            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
        ],
        defaultNodes: {
            // 'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },



    // 'checkUpdate': {
    //     key: 'checkUpdate',
    //     title: '{{lang}}Check Update',
    //     group: 'operator',

    //     parents: ['controlUnits'],

    //     UI: { type: 'condition', borderRadius: '8px', height: 44, bodyColor: '#333', textColor: '#333', border: '2px solid #d0d0d0', bodyColorS: '#ddd', bodyColorE: '#ddd' },
    //     icon: '/assets/icons/elements/email.png',
    //     headers: [
    //         { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}label',  placeholder: '{{lang}}insertLabel', required: true } },
    //         { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
    //     }
    // },





    'triggerOrders': {
        key: 'triggerOrders',
        title: 'Trigger Orders',
        group: 'trigger',
        UI: { type: 'circle', borderRadius: '50%', width: 120, bodyColor: '#30C193', bodyColorS: '#30C193', bodyColorE: '#3DB9B1' },
        icon: '/assets/icons/elements/image.png',

        headers: [
            { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}label', placeholder: '{{lang}}insertLabel', required: true } },

            {
                key: 'dashboard',
                type: 'SelectInput',
                information: {
                    label: '{{lang}}dashboard',
                    address: 'getMyDashboards',
                    filter: { filter: {} },
                    fields: { title: 'name', description: "description", value: '_id' },
                    type: 'api',
                    isSearchable: true,

                    placeholder: '{{lang}}texts.addThing.findThing',
                    required: true,
                }
            },



            {
                key: 'trigger',
                type: 'SelectInput',
                information: { label: '{{lang}}trigger', address: 'getTriggers', filter: {}, fields: { title: 'label', value: 'id' }, type: 'api', placeholder: '{{lang}}insert', required: true },

                dependencies: [{
                    refKey: 'dashboard',
                    targetKey: 'trigger',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'and',
                            conditions: {
                                1: { id: 1, source: { value: '@data.dashboard' }, operator: { value: '!=' }, target: { value: null } }
                            }
                        },
                    },
                    show: true,
                    init: true,
                    changeHeader: { key: 'information.filter.id', value: '@data.dashboard' },

                }],
                showMain: false
            },


            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },

        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },


    'schedule': {
        key: 'schedule',
        title: 'Schedule',
        group: 'trigger',
        UI: { type: 'circle', borderRadius: '50%', width: 120, bodyColor: '#D098A5', bodyColorS: '#D098A5', bodyColorE: '#BEA5AA', showIcon: '/assets/icons/elements/date.png' },

        headers: [
            { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}label', placeholder: '{{lang}}insertLabel', required: true } },
            // SCHEDULE
            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },


    // 'onUpdate': {
    //     key: 'onUpdate',
    //     title: 'On Update',
    //     group: 'trigger',
    //     UI: { type: 'circle', borderRadius: '50%', width: 120, bodyColor: '#D098A5', bodyColorS: '#93A8D0', bodyColorE: '#A3ABBD' },

    //     icon: '/assets/icons/elements/email.png',
    //     headers: [
    //         { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}label',  placeholder: '{{lang}}insertLabel', required: true } },
    //         { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
    //     ],
    //     defaultNodes: {
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },

    //     }
    // },



    'reference': {
        key: 'reference',
        title: 'Reference',
        group: 'trigger',
        UI: { type: 'circle', borderRadius: '50%', width: 120, bodyColor: '#D098A5', bodyColorS: '#93A8D0', bodyColorE: '#A3ABBD' },


        headers: [
            { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}label', placeholder: '{{lang}}insertLabel', required: true } },
            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
        ],
        defaultNodes: {
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },









    ///////***** ACTIONS *******


    // 'actionDevices': {
    //     key: 'actionDevices',
    //     title: 'Action Devices',
    //     group: 'action',
    //     isParent: true,
    //     icon: '/assets/icons/elements/email.png',
    // },

    'actionDevices': {
        key: 'actionDevices',
        title: 'Action Devices',
        group: 'action',
        // UI: { type: 'action', bodyColor: '#D098A5', bodyColorS: '#93A8D0', bodyColorE: '#A3ABBD' },
        // UI: { type: 'action', bodyColor: '#D5CABD', bodyColorS: '#04004A', bodyColorE: '#250B65', showIcon: 'https://www.flaticon.com/svg/static/icons/svg/59/59118.svg' },
        UI: { type: 'circle', borderRadius: '50%', width: 120, bodyColorS: '#0086AC', bodyColorE: '#00B0B8', showIcon: 'https://www.flaticon.com/svg/static/icons/svg/320/320281.svg' },

        icon: '/assets/icons/elements/email.png',
        headers: [
            { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}label', placeholder: '{{lang}}insertLabel', required: true } },

            {
                key: 'thing',
                type: 'AdvancedSelectInput',
                information: {
                    label: '{{lang}}thing',
                    address: 'getAppletThings',
                    filter: { applet: '{{appletId}}', onlyActions: true },

                    fields: { title: 'thing.name', image: 'thing.images', value: 'thing._id' },
                    type: 'api',
                    isSearchable: true,

                    placeholder: '{{lang}}texts.addThing.findThing',
                    required: true,
                }
            },


            {
                key: 'characteristic',
                type: 'SelectInput',
                information: { label: '{{lang}}Action', address: 'getCharactristics', filter: { actions: true }, fields: { title: 'label', value: 'dataObject' }, type: 'api', placeholder: '{{lang}}insert', required: true },
                dependencies: [{
                    refKey: 'thing',
                    targetKey: 'characteristic',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'and',
                            conditions: {
                                1: { id: 1, source: { value: '@data.thing' }, operator: { value: '!=' }, target: { value: null } },

                            }
                        },
                    },
                    show: true,
                    init: true,
                    changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                }],
                showMain: false
            },


            { key: 'outputType', type: 'SelectInput', information: { label: '{{lang}}Output Type', default: 'input', type: 'local', items: [{ value: 'input', title: 'Input Value' }, { value: 'custom', title: 'Custom Value' }], placeholder: '{{lang}}select', required: true }, showMain: true },

            {
                key: 'output',
                type: 'SmartInput',
                information: { label: '{{lang}}diagram.outputValue', singleLine: true, placeholder: '{{lang}}diagram.outputValue', required: false },
                dependencies: [{
                    refKey: 'outputType',
                    targetKey: 'output',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'and',
                            conditions: {
                                1: { id: 1, source: { value: '@data.outputType' }, operator: { value: '==' }, target: { value: 'custom' } },

                            }
                        },
                    },
                    show: true,
                    init: true,
                    // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                }],
            },


            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
            /// SELECT (VALUE)

        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
        }
    },






    // 'getValue': {
    //     key: 'getValue',
    //     title: 'Get Value',
    //     group: 'action',

    //     
    //     UI: { type: 'circle', borderRadius: '50%', width: 100, bodyColorS: '#3DB9B1', bodyColorE: '#00AAA0', showIcon: 'https://www.flaticon.com/svg/static/icons/svg/3721/3721726.svg' },
    //     headers: [
    //         { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}label',  placeholder: '{{lang}}insertLabel', required: true } },
    //         // TREE SELECT
    //         { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },

    //     }
    // },




    'email': {
        key: 'email',
        title: 'Email',
        group: 'action',

        icon: '/assets/icons/elements/email.png',
        UI: { type: 'circle', borderRadius: '50%', width: 100, bodyColorS: '#3DB9B1', bodyColorE: '#00AAA0', showIcon: 'https://www.flaticon.com/svg/static/icons/svg/3721/3721726.svg' },
        headers: [
            { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}label', placeholder: '{{lang}}insertLabel', required: true } },
            { key: 'subject', type: 'TextInput', col: '12', information: { label: '{{lang}}subject', placeholder: '{{lang}}subject', required: true } },
            { key: 'recipient', type: 'MultiSelectInput', col: '12', information: { label: '{{lang}}recipient', placeholder: '{{lang}}subject', required: true } },
            { key: 'content', type: 'EditorInput', col: '12', information: { label: '{{lang}}content', required: true } },
            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            // 'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },

        }
    },


    'sms': {
        key: 'sms',
        title: 'SMS',
        group: 'action',

        icon: '/assets/icons/elements/number.png',
        UI: { type: 'circle', borderRadius: '50%', width: 100, bodyColorS: '#3DB9B1', bodyColorE: '#00AAA0', showIcon: 'https://www.flaticon.com/svg/static/icons/svg/3721/3721726.svg' },
        headers: [
            { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}label', placeholder: '{{lang}}insertLabel', required: true } },
            { key: 'recipient', type: 'MultiSelectInput', col: '12', information: { label: '{{lang}}recipient', address: 'getAppletExtraInfo', filter: { type: "users", applet: "{{appletId}}" }, fields: { title: 'user.fullname', value: 'user._id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}subject', required: true } },
            { key: 'content', type: 'SmartInput', col: '12', information: { label: '{{lang}}content', required: true } },
            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            // 'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },

        }
    },


    'call': {
        key: 'call',
        title: 'Call',
        group: 'action',

        icon: '/assets/icons/elements/number.png',
        UI: { type: 'circle', borderRadius: '50%', width: 100, bodyColorS: '#3DB9B1', bodyColorE: '#00AAA0', showIcon: 'https://www.flaticon.com/svg/static/icons/svg/3721/3721726.svg' },
        headers: [
            { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}label', placeholder: '{{lang}}insertLabel', required: true } },
            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            // 'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },

        }
    },


    'notification': {
        key: 'notification',
        title: 'Notification',
        group: 'action',

        icon: '/assets/icons/elements/image.png',
        UI: { type: 'circle', borderRadius: '50%', width: 100, bodyColorS: '#3DB9B1', bodyColorE: '#00AAA0', showIcon: 'https://www.flaticon.com/svg/static/icons/svg/3721/3721726.svg' },
        headers: [
            { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}label', placeholder: '{{lang}}insertLabel', required: true } },
            { key: 'subject', type: 'TextInput', col: '12', information: { label: '{{lang}}subject', placeholder: '{{lang}}subject', required: true } },
            { key: 'recipient', type: 'MultiSelectInput', col: '12', information: { label: '{{lang}}recipient', placeholder: '{{lang}}subject', required: true } },
            { key: 'content', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}content', required: true } },
            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            // 'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },

        }
    },


    // 'wait': {
    //     key: 'wait',
    //     title: 'Wait',
    //     group: 'action',

    //     icon: 'https://www.flaticon.com/svg/static/icons/svg/726/726573.svg',
    //     UI: { type: 'circle', borderRadius: '50%', width: 100, bodyColorS: '#3DB9B1', bodyColorE: '#00AAA0', showIcon: 'https://www.flaticon.com/svg/static/icons/svg/3721/3721726.svg' },
    //     headers: [
    //         { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}label',  placeholder: '{{lang}}insertLabel', required: true } },
    //         // TREE SELECT
    //         { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
    //     ],
    //     defaultNodes: {
    //         'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
    //         'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },

    //     }
    // },


    'telegram': {
        key: 'telegram',
        title: 'Telegram',
        group: 'action',
        icon: '/assets/icons/elements/image.png',
        UI: { type: 'circle', borderRadius: '50%', width: 100, bodyColorS: '#3DB9B1', bodyColorE: '#00AAA0', showIcon: 'https://www.flaticon.com/svg/static/icons/svg/3721/3721726.svg' },
        headers: [
            { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}label', placeholder: '{{lang}}insertLabel', required: true } },
            { key: 'recipient', type: 'MultiSelectInput', col: '12', information: { label: '{{lang}}recipient', placeholder: '{{lang}}subject', required: true } },
            { key: 'content', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}content', required: true } },
            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            // 'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },






    ///////***** CONDITOINS *******


    // 'if': {
    //     key: 'if',
    //     title: 'IF',
    //     group: 'condition',
    //     headerColor: '#778899',
    //     bodyColor: '#dfe6f0',
    //     
    //     headers: [
    //         { key: 'name', type: 'TextInput', col: '6', information: { label: '{{lang}}name', icon: 'https://image.flaticon.com/icons/svg/941/941581.svg', placeholder: '{{lang}}insertName', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input-1': { key: 'input-1', label: '1st Input', type: 'input', position: 'left' },
    //         'input-2': { key: 'input-2', label: '2st Input', type: 'input', position: 'left' },
    //         'output-1': { key: 'output-1', label: '1st Output', type: 'output', position: 'right' },
    //         'output-2': { key: 'output-2', label: '2st Output', type: 'output', position: 'right' },
    //     }
    // },



    // 'and': {
    //     key: 'and',
    //     title: 'AND',
    //     group: 'condition',
    //     headerColor: '#778899',
    //     bodyColor: '#dfe6f0',
    //     icon: 'https://www.flaticon.com/svg/static/icons/svg/726/726573.svg',
    //     headers: [
    //         { key: 'name', type: 'TextInput', col: '6', information: { label: '{{lang}}name', icon: 'https://image.flaticon.com/icons/svg/941/941581.svg', placeholder: '{{lang}}insertName', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input-1': { key: 'input-1', label: '1st Input', type: 'input', position: 'left' },
    //         'input-2': { key: 'input-2', label: '2st Input', type: 'input', position: 'left' },
    //         'output-1': { key: 'output-1', label: '1st Output', type: 'output', position: 'right' },
    //         'output-2': { key: 'output-2', label: '2st Output', type: 'output', position: 'right' },
    //     }
    // },

    // 'or': {
    //     key: 'or',
    //     title: 'OR',
    //     group: 'condition',
    //     headerColor: '#778899',
    //     bodyColor: '#dfe6f0',
    //     icon: '/assets/icons/elements/image.png',
    //     headers: [
    //         { key: 'name', type: 'TextInput', col: '6', information: { label: '{{lang}}name', icon: 'https://image.flaticon.com/icons/svg/941/941581.svg', placeholder: '{{lang}}insertName', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input-1': { key: 'input-1', label: '1st Input', type: 'input', position: 'left' },
    //         'input-2': { key: 'input-2', label: '2st Input', type: 'input', position: 'left' },
    //         'output-1': { key: 'output-1', label: '1st Output', type: 'output', position: 'right' },
    //         'output-2': { key: 'output-2', label: '2st Output', type: 'output', position: 'right' },
    //     }
    // },




    ///////***** FLOW CONTROL *******


    // 'merge': {
    //     key: 'merge',
    //     title: 'Merge',
    //     group: 'operator',
    //     headerColor: '#778899',
    //     bodyColor: '#dfe6f0',
    //     
    //     headers: [
    //         { key: 'name', type: 'TextInput', col: '6', information: { label: '{{lang}}name', icon: 'https://image.flaticon.com/icons/svg/941/941581.svg', placeholder: '{{lang}}insertName', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input-1': { key: 'input-1', label: '1st Input', type: 'input', position: 'left' },
    //         'input-2': { key: 'input-2', label: '2st Input', type: 'input', position: 'left' },
    //         'output-1': { key: 'output-1', label: '1st Output', type: 'output', position: 'right' },
    //         'output-2': { key: 'output-2', label: '2st Output', type: 'output', position: 'right' },
    //     }
    // },



    // 'split': {
    //     key: 'split',
    //     title: 'Split',
    //     group: 'operator',
    //     headerColor: '#778899',
    //     bodyColor: '#dfe6f0',
    //     icon: 'https://www.flaticon.com/svg/static/icons/svg/726/726573.svg',
    //     headers: [
    //         { key: 'name', type: 'TextInput', col: '6', information: { label: '{{lang}}name', icon: 'https://image.flaticon.com/icons/svg/941/941581.svg', placeholder: '{{lang}}insertName', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input-1': { key: 'input-1', label: '1st Input', type: 'input', position: 'left' },
    //         'input-2': { key: 'input-2', label: '2st Input', type: 'input', position: 'left' },
    //         'output-1': { key: 'output-1', label: '1st Output', type: 'output', position: 'right' },
    //         'output-2': { key: 'output-2', label: '2st Output', type: 'output', position: 'right' },
    //     }
    // },


    'exitFromWorkflow': {
        key: 'exitFromWorkflow',
        title: 'Exit From Workflow',
        group: 'operator',
        parents: ['controlUnits'],
        // headerColor: '#778899',
        // bodyColor: '#dfe6f0',
        icon: '/assets/icons/elements/exitFromWorkflow.svg',
        UI: { type: 'circle', borderRadius: '50%', width: 100, bodyColorS: '#ee5050', bodyColorE: '#E5417C', showIcon: 'https://www.flaticon.com/svg/static/icons/svg/3721/3721726.svg' },
        headers: [
            { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}label', placeholder: '{{lang}}insertLabel', required: true } },
            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            // 'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },



    'linkToAnotherWorkflow': {
        key: 'linkToAnotherWorkflow',
        title: 'Link To Another Workflow',
        group: 'operator',
        parents: ['controlUnits'],
        icon: '/assets/icons/elements/linkToAnotherWorkflow.svg',
        UI: { type: 'circle', borderRadius: '50%', width: 100, bodyColorS: '#007aff', bodyColorE: '#6B6CED', showIcon: 'https://www.flaticon.com/svg/static/icons/svg/3721/3721726.svg' },
        headers: [
            { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}label', placeholder: '{{lang}}insertLabel', required: true } },
            // TREE SELECT
            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}insertDescription', required: false } },
        ],
        defaultNodes: {
            'input': { key: 'input', label: 'Input', type: 'input', position: 'left' },
            'output': { key: 'output', label: 'Output', type: 'output', position: 'right' },
        }
    },












    /////////////////

    // 'formSubmit': {
    //     key: 'formSubmit',
    //     title: 'Form Submit',
    //     group: 'trigger',
    //     headerColor: '#778899',
    //     bodyColor: '#dfe6f0',
    //     icon: '/assets/icons/elements/email.png',
    //     headers: [
    //         { key: 'name', type: 'TextInput', col: '6', information: { label: '{{lang}}name', icon: 'https://image.flaticon.com/icons/svg/941/941581.svg', placeholder: '{{lang}}insertName', required: true } },
    //     ],
    //     defaultNodes: {
    //         'input-1': { key: 'input-1', label: '1st Input', type: 'input', position: 'left' },
    //         'input-2': { key: 'input-2', label: '2st Input', type: 'input', position: 'left' },
    //         'output-1': { key: 'output-1', label: '1st Output', type: 'output', position: 'right' },
    //         'output-2': { key: 'output-2', label: '2st Output', type: 'output', position: 'right' },
    //     }
    // },








    // 'listEntry': { key: 'listEntry', title: 'List Entry', group: 'trigger', headerColor: '#778899', bodyColor: '#dfe6f0', icon: '/assets/icons/elements/number.png' },
    // 'fieldUpdate': { key: 'fieldUpdate', title: 'Field Update', group: 'trigger', headerColor: '#778899', bodyColor: '#dfe6f0', icon: '/assets/icons/elements/image.png' },
    // 'openTrigger': { key: 'openTrigger', title: 'Open Trigger', group: 'trigger', headerColor: '#778899', bodyColor: '#dfe6f0', icon: '/assets/icons/elements/date.png' },

    // 'sendEmail': { key: 'sendEmail', title: 'Send Email', group: 'proccess', headerColor: '#778899', bodyColor: '#dfe6f0', icon: '/assets/icons/elements/date.png' },
    // 'sendSMS': {
    //     key: 'sendSMS',
    //     title: 'Send SMS',
    //     group: 'proccess',
    //     headerColor: '#778899',
    //     bodyColor: '#dfe6f0',
    //     icon: 'https://www.flaticon.com/svg/static/icons/svg/726/726573.svg'
    // },
    // 'wait': { key: 'wait', title: 'Wait', group: 'proccess', headerColor: '#778899', bodyColor: '#dfe6f0', icon: '/assets/icons/elements/email.png' },


}


export { diagramComponents, diagramGroups }